import "./base_feed.7169a3a4.js";


function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("4V6Ya", function(module, exports) {

$parcel$export(module.exports, "lightenButtonInteractions", () => $3951e44e16bd936f$export$e53a4e9857761c20);
$parcel$export(module.exports, "darkenButtonInteractions", () => $3951e44e16bd936f$export$415728943b52387f);
$parcel$export(module.exports, "lightenButtonInteractionsText", () => $3951e44e16bd936f$export$1537f4aa271af4);
$parcel$export(module.exports, "darkenButtonInteractionsText", () => $3951e44e16bd936f$export$9d0cefe9cddcc459);
$parcel$export(module.exports, "lightenButtonInteractionsAnotherElement", () => $3951e44e16bd936f$export$a928a2121a9d5bc2);
$parcel$export(module.exports, "darkenButtonInteractionsAnotherElement", () => $3951e44e16bd936f$export$4ad2d28eb9a7114d);
$parcel$export(module.exports, "lightenButtonInteractionsAnotherElementText", () => $3951e44e16bd936f$export$a71c8922902ebb7d);
$parcel$export(module.exports, "darkenButtonInteractionsAnotherElementText", () => $3951e44e16bd936f$export$61e48f0f7ada4f25);
function $3951e44e16bd936f$export$e53a4e9857761c20(element) {
    // Get the current background color
    let color = '';
    if (!!element.style.backgroundColor) color = element.style.backgroundColor;
    else if (!!window.getComputedStyle(element).backgroundColor) color = window.getComputedStyle(element).backgroundColor;
    else color = "rgb(255, 255, 255)";
    // Extract the RGB components
    let [r, g, b] = color.match(/\d+/g).map(Number);
    element.addEventListener('mouseout', (e)=>$3951e44e16bd936f$var$adjustBrightness(element, r, g, b));
    element.addEventListener('mouseover', (e)=>$3951e44e16bd936f$var$adjustBrightness(element, r + 15, g + 15, b + 15));
    element.addEventListener('mousedown', (e)=>$3951e44e16bd936f$var$adjustBrightness(element, r + 30, g + 30, b + 30));
    element.addEventListener('mouseup', (e)=>$3951e44e16bd936f$var$adjustBrightness(element, r, g, b));
}
function $3951e44e16bd936f$export$415728943b52387f(element) {
    // Get the current background color
    let color = '';
    if (!!element.style.backgroundColor) color = element.style.backgroundColor;
    else if (!!window.getComputedStyle(element).backgroundColor) color = window.getComputedStyle(element).backgroundColor;
    else color = "rgb(255, 255, 255)";
    // Extract the RGB components
    let [r, g, b] = color.match(/\d+/g).map(Number);
    element.addEventListener('mouseout', (e)=>$3951e44e16bd936f$var$adjustBrightness(element, r, g, b));
    element.addEventListener('mouseover', (e)=>$3951e44e16bd936f$var$adjustBrightness(element, r - 20, g - 20, b - 20));
    element.addEventListener('mousedown', (e)=>$3951e44e16bd936f$var$adjustBrightness(element, r - 40, g - 40, b - 40));
    element.addEventListener('mouseup', (e)=>$3951e44e16bd936f$var$adjustBrightness(element, r, g, b));
}
function $3951e44e16bd936f$var$adjustBrightness(element, r, g, b) {
    // Apply the new color to the element
    element.style.backgroundColor = `rgb(${r}, ${g}, ${b})`;
}
function $3951e44e16bd936f$export$1537f4aa271af4(element) {
    // Get the current background color
    let color = '';
    if (!!element.style.color) color = element.style.color;
    else if (!!window.getComputedStyle(element).color) color = window.getComputedStyle(element).color;
    else color = "rgb(255, 255, 255)";
    // Extract the RGB components
    let [r, g, b] = color.match(/\d+/g).map(Number);
    element.addEventListener('mouseout', (e)=>$3951e44e16bd936f$var$adjustBrightnessText(element, r, g, b));
    element.addEventListener('mouseover', (e)=>$3951e44e16bd936f$var$adjustBrightnessText(element, r + 15, g + 15, b + 15));
    element.addEventListener('mousedown', (e)=>$3951e44e16bd936f$var$adjustBrightnessText(element, r + 50, g + 50, b + 50));
    element.addEventListener('mouseup', (e)=>$3951e44e16bd936f$var$adjustBrightnessText(element, r, g, b));
}
function $3951e44e16bd936f$export$9d0cefe9cddcc459(element) {
    // Get the current background color
    let color = '';
    if (!!element.style.color) color = element.style.color;
    else if (!!window.getComputedStyle(element).color) color = window.getComputedStyle(element).color;
    else color = "rgb(255, 255, 255)";
    // Extract the RGB components
    let [r, g, b] = color.match(/\d+/g).map(Number);
    element.addEventListener('mouseout', (e)=>$3951e44e16bd936f$var$adjustBrightnessText(element, r, g, b));
    element.addEventListener('mouseover', (e)=>$3951e44e16bd936f$var$adjustBrightnessText(element, r - 20, g - 20, b - 20));
    element.addEventListener('mousedown', (e)=>$3951e44e16bd936f$var$adjustBrightnessText(element, r - 60, g - 60, b - 60));
    element.addEventListener('mouseup', (e)=>$3951e44e16bd936f$var$adjustBrightnessText(element, r, g, b));
}
function $3951e44e16bd936f$var$adjustBrightnessText(element, r, g, b) {
    // Apply the new color to the element
    element.style.color = `rgb(${r}, ${g}, ${b})`;
}
function $3951e44e16bd936f$export$a928a2121a9d5bc2(element, elementAnother) {
    // Get the current background color
    let color = '';
    if (!!elementAnother.style.backgroundColor) color = elementAnother.style.backgroundColor;
    else if (!!window.getComputedStyle(elementAnother).backgroundColor) color = window.getComputedStyle(elementAnother).backgroundColor;
    else color = "rgb(255, 255, 255)";
    // Extract the RGB components
    let [r, g, b] = color.match(/\d+/g).map(Number);
    element.addEventListener('mouseout', (e)=>$3951e44e16bd936f$var$adjustBrightness(elementAnother, r, g, b));
    element.addEventListener('mouseover', (e)=>$3951e44e16bd936f$var$adjustBrightness(elementAnother, r + 15, g + 15, b + 15));
    element.addEventListener('mousedown', (e)=>$3951e44e16bd936f$var$adjustBrightness(elementAnother, r + 30, g + 30, b + 30));
    element.addEventListener('mouseup', (e)=>$3951e44e16bd936f$var$adjustBrightness(elementAnother, r, g, b));
}
function $3951e44e16bd936f$export$4ad2d28eb9a7114d(element, elementAnother) {
    // Get the current background color
    let color = '';
    if (!!elementAnother.style.backgroundColor) color = elementAnother.style.backgroundColor;
    else if (!!window.getComputedStyle(elementAnother).backgroundColor) color = window.getComputedStyle(elementAnother).backgroundColor;
    else color = "rgb(255, 255, 255)";
    // Extract the RGB components
    let [r, g, b] = color.match(/\d+/g).map(Number);
    element.addEventListener('mouseout', (e)=>$3951e44e16bd936f$var$adjustBrightness(elementAnother, r, g, b));
    element.addEventListener('mouseover', (e)=>$3951e44e16bd936f$var$adjustBrightness(elementAnother, r - 20, g - 20, b - 20));
    element.addEventListener('mousedown', (e)=>$3951e44e16bd936f$var$adjustBrightness(elementAnother, r - 40, g - 40, b - 40));
    element.addEventListener('mouseup', (e)=>$3951e44e16bd936f$var$adjustBrightness(elementAnother, r, g, b));
}
function $3951e44e16bd936f$export$a71c8922902ebb7d(element, elementAnother) {
    // Get the current background color
    let color = '';
    if (!!elementAnother.style.backgroundColor) color = elementAnother.style.backgroundColor;
    else if (!!window.getComputedStyle(elementAnother).backgroundColor) color = window.getComputedStyle(elementAnother).backgroundColor;
    else color = "rgb(255, 255, 255)";
    // Extract the RGB components
    let [r, g, b] = color.match(/\d+/g).map(Number);
    element.addEventListener('mouseout', (e)=>$3951e44e16bd936f$var$adjustBrightnessText(elementAnother, r, g, b));
    element.addEventListener('mouseover', (e)=>$3951e44e16bd936f$var$adjustBrightnessText(elementAnother, r + 15, g + 15, b + 15));
    element.addEventListener('mousedown', (e)=>$3951e44e16bd936f$var$adjustBrightnessText(elementAnother, r + 50, g + 50, b + 50));
    element.addEventListener('mouseup', (e)=>$3951e44e16bd936f$var$adjustBrightnessText(elementAnother, r, g, b));
}
function $3951e44e16bd936f$export$61e48f0f7ada4f25(element, elementAnother) {
    // Get the current background color
    let color = '';
    if (!!elementAnother.style.backgroundColor) color = elementAnother.style.backgroundColor;
    else if (!!window.getComputedStyle(elementAnother).backgroundColor) color = window.getComputedStyle(elementAnother).backgroundColor;
    else color = "rgb(255, 255, 255)";
    // Extract the RGB components
    let [r, g, b] = color.match(/\d+/g).map(Number);
    element.addEventListener('mouseout', (e)=>$3951e44e16bd936f$var$adjustBrightnessText(elementAnother, r, g, b));
    element.addEventListener('mouseover', (e)=>$3951e44e16bd936f$var$adjustBrightnessText(elementAnother, r - 20, g - 20, b - 20));
    element.addEventListener('mousedown', (e)=>$3951e44e16bd936f$var$adjustBrightnessText(elementAnother, r - 60, g - 60, b - 60));
    element.addEventListener('mouseup', (e)=>$3951e44e16bd936f$var$adjustBrightnessText(elementAnother, r, g, b));
}

});

parcelRegister("9lyWO", function(module, exports) {

$parcel$export(module.exports, "GREY_BUTTON_COLOR", () => $6ce12f1769c81419$export$6d1ff5ea44ef679d);
$parcel$export(module.exports, "DARK_GREY_BUTTON_COLOR", () => $6ce12f1769c81419$export$95e84cfc81412ca1);
$parcel$export(module.exports, "WHITE_BUTTON_COLOR", () => $6ce12f1769c81419$export$3aa8c5b68636176b);
$parcel$export(module.exports, "RED_BUTTON_COLOR", () => $6ce12f1769c81419$export$22c1a135d192f50);
$parcel$export(module.exports, "LIGHT_BLACK_BUTTON_COLOR", () => $6ce12f1769c81419$export$b069fbd72ca66dc1);
$parcel$export(module.exports, "BLACK_BUTTON_COLOR", () => $6ce12f1769c81419$export$bfa890547ef9076c);
$parcel$export(module.exports, "ROYAL_BLUE_COLOR", () => $6ce12f1769c81419$export$410c56c0f1230bb7);
const $6ce12f1769c81419$export$6d1ff5ea44ef679d = 'rgb(223, 223, 223)';
const $6ce12f1769c81419$export$95e84cfc81412ca1 = 'rgb(80, 80, 80)';
const $6ce12f1769c81419$export$3aa8c5b68636176b = 'rgb(255, 255, 255)';
const $6ce12f1769c81419$export$22c1a135d192f50 = 'rgb(224, 65, 65)';
const $6ce12f1769c81419$export$b069fbd72ca66dc1 = 'rgb(39, 39, 39)';
const $6ce12f1769c81419$export$bfa890547ef9076c = 'rgb(0, 0, 0)';
const $6ce12f1769c81419$export$410c56c0f1230bb7 = 'rgb(90, 123, 223)';

});

parcelRegister("7NPUP", function(module, exports) {

$parcel$export(module.exports, "API_GATEWAY", () => $5ae5615dff4fd4a2$export$80ec22f7597f1f8f);
$parcel$export(module.exports, "API_GATEWAY_NOSLASH", () => $5ae5615dff4fd4a2$export$87321e0e083f400a);
$parcel$export(module.exports, "API_UPLOAD_URL", () => $5ae5615dff4fd4a2$export$35476ce5405c7a8);
$parcel$export(module.exports, "SITE_URL", () => $5ae5615dff4fd4a2$export$4304db42250cf41e);
const $5ae5615dff4fd4a2$export$80ec22f7597f1f8f = "https://api.branchof.art/api/";
const $5ae5615dff4fd4a2$export$87321e0e083f400a = "https://api.branchof.art/api";
const $5ae5615dff4fd4a2$export$35476ce5405c7a8 = "https://upload-media.branchof.art";
const $5ae5615dff4fd4a2$export$4304db42250cf41e = "https://branchof.art";

});

parcelRegister("5ZqHF", function(module, exports) {

$parcel$export(module.exports, "insertImageValue", () => $45c75cfab064a69f$export$7ad6e189fee6f1c7);

var $7NPUP = parcelRequire("7NPUP");
async function $45c75cfab064a69f$export$7ad6e189fee6f1c7(img, picPath) {
    img.src = await $45c75cfab064a69f$export$b7d53944959f8052(picPath);
    img.onerror = async ()=>{
        const url = await $45c75cfab064a69f$var$getFilesUrl();
        img.src = url + picPath;
        img.onerror = ()=>{
            img.src = $45c75cfab064a69f$var$imgError();
        };
    };
}
async function $45c75cfab064a69f$export$b7d53944959f8052(picPath) {
    let url = localStorage.getItem('branchof_config_files_url');
    if (url === null || url === undefined) url = await $45c75cfab064a69f$var$getFilesUrl();
    return url + picPath;
}
let $45c75cfab064a69f$var$configFetchPromise = null;
async function $45c75cfab064a69f$var$getFilesUrl() {
    if ($45c75cfab064a69f$var$configFetchPromise) return await $45c75cfab064a69f$var$configFetchPromise;
    $45c75cfab064a69f$var$configFetchPromise = fetch((0, $7NPUP.API_GATEWAY) + 'config/frontend/image-link').then((res)=>res.text()).then((url)=>{
        console.log("Fetched config URL:", url);
        localStorage.setItem('branchof_config_files_url', url);
        return url;
    });
    const url = await $45c75cfab064a69f$var$configFetchPromise;
    localStorage.setItem('branchof_config_files_url', url);
    return await url;
}
function $45c75cfab064a69f$var$imgError() {
    return '/images/logo/logo3_smooth.png';
}

});

parcelRegister("iqZMU", function(module, exports) {

$parcel$export(module.exports, "createElement", () => $d6ba957c60af9631$export$c8a8987d4410bf2d);
function $d6ba957c60af9631$export$c8a8987d4410bf2d(elementValue, id, classList) {
    const element = document.createElement(elementValue);
    if (id !== null) element.setAttribute('id', id);
    if (classList !== null) for (let i of classList)element.classList.add(i);
    return element;
}
function $d6ba957c60af9631$export$7094a064528c7fee(uri, elementValue, id, classList) {
    const element = document.createElementNS(uri, elementValue);
    if (id !== null) element.setAttribute('id', id);
    if (classList !== null) for (let i of classList)element.classList.add(i);
    return element;
}

});

parcelRegister("5ZiIO", function(module, exports) {

$parcel$export(module.exports, "createPreview", () => $45c12bfed228ad6b$export$dd58ed3d8e4bd91);

var $5ZqHF = parcelRequire("5ZqHF");
const $45c12bfed228ad6b$var$methods = {
    'YT_URL': $45c12bfed228ad6b$var$youtubeMethodInit,
    'SCL_URL': $45c12bfed228ad6b$var$soundCloudMethodInit,
    'PIC_FILE': $45c12bfed228ad6b$var$imageFileMethodInit,
    'IDEA': $45c12bfed228ad6b$var$ideaMethodInit
};
function $45c12bfed228ad6b$export$dd58ed3d8e4bd91(preview, onLoadedFunction = null) {
    const method = preview.method;
    console.log("preview ", preview);
    const methodFunction = $45c12bfed228ad6b$var$methods[method];
    if (methodFunction instanceof Function) return methodFunction(preview, onLoadedFunction);
    else throw new Error("invalid preview function!");
}
function $45c12bfed228ad6b$var$ideaMethodInit(preview, onLoadedFunction) {
    const previewContent = document.createElement('div');
    previewContent.classList.add("idea-preview-content");
    const previewContentImageBox = document.createElement('div');
    previewContentImageBox.classList.add("idea-preview-content-image-box");
    const lightbulb = document.createElement('img');
    if (onLoadedFunction !== null) lightbulb.addEventListener('load', ()=>{
        if (lightbulb.src && lightbulb.src !== "about:blank" && lightbulb.src !== null) onLoadedFunction();
    });
    previewContent.setOnLoadedImage = (onLoadedFunction)=>$45c12bfed228ad6b$var$setOnLoadedImage(lightbulb, onLoadedFunction);
    lightbulb.src = '/images/idea/idea-lightbulb.webp';
    lightbulb.classList.add("idea-preview-content-lightbulb");
    /*
    const explosionMono = document.createElement('img');
    explosionMono.src = '/images/idea/idea-explosion-mono.png';
    explosionMono.classList.add("idea-preview-content-explosion");
    */ const ideaCaption = document.createElement('p');
    ideaCaption.innerText = 'An idea';
    previewContentImageBox.append(lightbulb);
    //previewContentImageBox.append(explosionMono);
    previewContent.append(previewContentImageBox, ideaCaption);
    previewContent.lightbulb = lightbulb;
    return previewContent;
}
function $45c12bfed228ad6b$var$youtubeMethodInit(preview, onLoadedFunction) {
    const previewUrl = `https://www.youtube.com/embed/${preview.videoId}?feature=oembed`;
    const previewContent = document.createElement('iframe');
    previewContent.classList.add("youtube-preview-content");
    if (onLoadedFunction !== null) previewContent.addEventListener('load', ()=>{
        if (previewContent.src && previewContent.src !== "about:blank" && previewContent.src !== null) onLoadedFunction();
    });
    previewContent.setOnLoadedIframe = (onLoadedFunction)=>$45c12bfed228ad6b$var$setOnLoadedIframe(previewContent, onLoadedFunction);
    previewContent.src = previewUrl;
    return previewContent;
}
function $45c12bfed228ad6b$var$soundCloudMethodInit(preview, onLoadedFunction) {
    console.log("trackId " + preview.trackId);
    const previewUrl = `https://w.soundcloud.com/player/?visual=true&url=${encodeURIComponent(`https://api.soundcloud.com/tracks/${preview.trackId}`)}&show_artwork=true`;
    const previewContent = document.createElement('iframe');
    previewContent.classList.add("soundcloud-preview-content");
    if (onLoadedFunction !== null) previewContent.addEventListener('load', ()=>{
        if (previewContent.src && previewContent.src !== "about:blank" && previewContent.src !== null) onLoadedFunction();
    });
    previewContent.setOnLoadedIframe = (onLoadedFunction)=>$45c12bfed228ad6b$var$setOnLoadedIframe(previewContent, onLoadedFunction);
    previewContent.src = previewUrl;
    return previewContent;
}
function $45c12bfed228ad6b$var$imageFileMethodInit(preview, onLoadedFunction) {
    const previewPath = preview.key;
    const previewFile = document.createElement('img');
    previewFile.classList.add("image-preview-content");
    if (onLoadedFunction !== null) previewFile.addEventListener('load', ()=>{
        if (previewFile.src && previewFile.src !== "about:blank" && previewFile.src !== null) onLoadedFunction();
    });
    previewFile.setOnLoadedImage = (onLoadedFunction)=>$45c12bfed228ad6b$var$setOnLoadedImage(previewFile, onLoadedFunction);
    (0, $5ZqHF.insertImageValue)(previewFile, previewPath);
    return previewFile;
}
function $45c12bfed228ad6b$var$pdfFileMethodInit(preview) {}
function $45c12bfed228ad6b$var$setOnLoadedIframe(iframe, onLoadedFunction) {
    if (!(onLoadedFunction instanceof Function)) throw new Error('Must be function!');
    iframe.addEventListener('load', ()=>{
        if (iframe.src && iframe.src !== "about:blank" && iframe.src !== null) onLoadedFunction();
    });
}
function $45c12bfed228ad6b$var$setOnLoadedImage(img, onLoadedFunction) {
    if (!(onLoadedFunction instanceof Function)) throw new Error('Must be function!');
    img.addEventListener('load', ()=>{
        if (img.src && img.src !== "about:blank" && img.src !== null) onLoadedFunction();
    });
}
function $45c12bfed228ad6b$var$setOnLoadedIdea(ideaElement, onLoadedFunction) {
    if (!(onLoadedFunction instanceof Function)) throw new Error('Must be function!');
    const lightbulb = ideaElement.lightbulb;
    lightbulb.addEventListener('load', ()=>{
        if (lightbulb.src && lightbulb.src !== "about:blank" && lightbulb.src !== null) onLoadedFunction();
    });
}

});

parcelRegister("81Clf", function(module, exports) {

$parcel$export(module.exports, "makeNewButton", () => $5d7c289a1ee23ce0$export$9450e554c13dc400);
$parcel$export(module.exports, "makeNewButtonAffectingDifferentElement", () => $5d7c289a1ee23ce0$export$90e74eef406d488c);

var $9lyWO = parcelRequire("9lyWO");

var $4V6Ya = parcelRequire("4V6Ya");
const $5d7c289a1ee23ce0$var$backgroundColors = {
    'white': (0, $9lyWO.WHITE_BUTTON_COLOR),
    'grey': (0, $9lyWO.GREY_BUTTON_COLOR),
    'gray': (0, $9lyWO.GREY_BUTTON_COLOR),
    'dark-grey': (0, $9lyWO.DARK_GREY_BUTTON_COLOR),
    'dark-gray': (0, $9lyWO.DARK_GREY_BUTTON_COLOR),
    'light-black': (0, $9lyWO.LIGHT_BLACK_BUTTON_COLOR),
    'black': (0, $9lyWO.BLACK_BUTTON_COLOR),
    'red': (0, $9lyWO.RED_BUTTON_COLOR),
    'royalblue': (0, $9lyWO.ROYAL_BLUE_COLOR)
};
const $5d7c289a1ee23ce0$var$buttonInteractions = {
    'lighten': (0, $4V6Ya.lightenButtonInteractions),
    'darken': (0, $4V6Ya.darkenButtonInteractions)
};
const $5d7c289a1ee23ce0$var$buttonInteractionsText = {
    'lighten': (0, $4V6Ya.lightenButtonInteractionsText),
    'darken': (0, $4V6Ya.darkenButtonInteractionsText)
};
const $5d7c289a1ee23ce0$var$buttonInteractionsAnother = {
    'lighten': (0, $4V6Ya.lightenButtonInteractionsAnotherElement),
    'darken': (0, $4V6Ya.darkenButtonInteractionsAnotherElement)
};
const $5d7c289a1ee23ce0$var$buttonInteractionsTextAnother = {
    'lighten': (0, $4V6Ya.lightenButtonInteractionsAnotherElementText),
    'darken': (0, $4V6Ya.darkenButtonInteractionsAnotherElementText)
};
function $5d7c289a1ee23ce0$export$9450e554c13dc400(element, buttonBackground, buttonColor, innerText, interactions = null, interactionsText = null) {
    element.style.background = buttonBackground;
    if ($5d7c289a1ee23ce0$var$backgroundColors[buttonBackground] !== null && $5d7c289a1ee23ce0$var$backgroundColors[buttonBackground] !== undefined) element.style.background = $5d7c289a1ee23ce0$var$backgroundColors[buttonBackground];
    else element.style.background = buttonBackground;
    if (interactions !== null) $5d7c289a1ee23ce0$var$buttonInteractions[interactions](element);
    if ($5d7c289a1ee23ce0$var$backgroundColors[buttonColor] !== null && $5d7c289a1ee23ce0$var$backgroundColors[buttonBackground] !== undefined) element.style.color = $5d7c289a1ee23ce0$var$backgroundColors[buttonColor];
    else element.style.color = buttonColor;
    if (interactionsText !== null) $5d7c289a1ee23ce0$var$buttonInteractionsText[interactionsText](element);
    if (innerText !== null) element.innerText = innerText;
}
function $5d7c289a1ee23ce0$export$90e74eef406d488c(element, elementAffected, buttonBackground, buttonColor, innerText, interactions = null, interactionsText = null) {
    elementAffected.style.background = buttonBackground;
    if ($5d7c289a1ee23ce0$var$backgroundColors[buttonBackground] !== null) elementAffected.style.background = $5d7c289a1ee23ce0$var$backgroundColors[buttonBackground];
    else elementAffected.style.background = buttonBackground;
    if (interactions !== null) $5d7c289a1ee23ce0$var$buttonInteractionsAnother[interactions](element, elementAffected);
    if (interactionsText !== null) $5d7c289a1ee23ce0$var$buttonInteractionsTextAnother[interactionsText](element, elementAffected);
    elementAffected.style.color = buttonColor;
    if (innerText !== null) elementAffected.innerText = innerText;
}

});

parcelRegister("jFzoB", function(module, exports) {

$parcel$export(module.exports, "createLoadingScreen", () => $e51d4d8a76395cd9$export$780fe74f0233013a);

var $iqZMU = parcelRequire("iqZMU");
parcelRequire("5zOzO");
parcelRequire("81Clf");
parcelRequire("7NPUP");
function $e51d4d8a76395cd9$export$780fe74f0233013a(screenVerticalTopPX, screenVerticalBottomPX, circleSizePX) {
    const loadingScreen = (0, $iqZMU.createElement)('div', null, [
        'loading-screen'
    ]);
    loadingScreen.style.padding = `${Math.abs(screenVerticalTopPX - circleSizePX / 2)}px 0 ${Math.abs(screenVerticalBottomPX - circleSizePX / 2)}px 0`;
    const loadingCircle = (0, $iqZMU.createElement)('div', null, [
        'loading-circle-box'
    ]);
    loadingCircle.style.width = `${circleSizePX}px`;
    loadingCircle.style.height = `${circleSizePX}px`;
    loadingCircle.style.position = 'relative';
    const circleBig = (0, $iqZMU.createElement)('img', null, [
        'loading-circle-big',
        'loading-circle'
    ]);
    circleBig.src = '/images/big1.png';
    circleBig.style.width = `${circleSizePX * 0.75}px`;
    circleBig.style.height = `${circleSizePX * 0.75}px`;
    const circleSmall = (0, $iqZMU.createElement)('img', null, [
        'loading-circle-small',
        'loading-circle'
    ]);
    circleSmall.src = '/images/big1.png';
    circleSmall.style.width = `${circleSizePX * 0.55}px`;
    circleSmall.style.height = `${circleSizePX * 0.55}px`;
    loadingCircle.append(circleBig);
    loadingCircle.append(circleSmall);
    const loadingCaption = (0, $iqZMU.createElement)('p', null, null);
    loadingCaption.style.fontSize = `${circleSizePX * 0.15}px`;
    loadingCaption.innerText = 'Loading...';
    loadingScreen.append(loadingCircle);
    loadingScreen.append(loadingCaption);
    loadingScreen.loadingCircle = loadingCircle;
    loadingScreen.loadingCaption = loadingCaption;
    return loadingScreen;
}

});
parcelRegister("5zOzO", function(module, exports) {

$parcel$export(module.exports, "logOut", () => $40f7741e7fc8a034$export$464881f0a7cf0212);
$parcel$export(module.exports, "logOutWithTimeOut", () => $40f7741e7fc8a034$export$a6ab5bd9ea270f69);

var $7NPUP = parcelRequire("7NPUP");
async function $40f7741e7fc8a034$export$464881f0a7cf0212() {
    const response = await fetch((0, $7NPUP.API_GATEWAY) + "session/logout", {
        method: "DELETE",
        headers: {
            'Token-Auth': `${localStorage.branchof_access_token}`
        },
        credentials: "include"
    });
    localStorage.removeItem('branchof_access_token');
    localStorage.removeItem('branchof_access_username');
    window.location = '/login';
}
async function $40f7741e7fc8a034$export$a6ab5bd9ea270f69(timer = 3000) {
    const response = await fetch((0, $7NPUP.API_GATEWAY) + "session/logout", {
        method: "DELETE",
        headers: {
            'Token-Auth': `${localStorage.branchof_access_token}`
        },
        credentials: "include"
    });
    localStorage.removeItem('branchof_access_token');
    localStorage.removeItem('branchof_access_username');
    setTimeout(()=>{
        window.location = '/login';
    }, timer);
}

});


parcelRegister("fIqNW", function(module, exports) {

$parcel$export(module.exports, "createLeftSideContent", () => $b70fc1debd16810b$export$6a7e26f7c4d4dcbf);

var $iqZMU = parcelRequire("iqZMU");

var $5zOzO = parcelRequire("5zOzO");

var $81Clf = parcelRequire("81Clf");

var $7NPUP = parcelRequire("7NPUP");
const $b70fc1debd16810b$var$LEFT_SIDE_LABEL_COLOR = 'rgb(235, 235, 235)';
function $b70fc1debd16810b$export$6a7e26f7c4d4dcbf(loginToken, profile_pic, username, name) {
    const elementsList = [];
    //---------------My Profile-------------------------
    const avatarAndProfile = (0, $iqZMU.createElement)('a', 'left-side-content-my-profile', [
        'left-side-content-row'
    ]);
    const avatar = (0, $iqZMU.createElement)('img', null, null);
    avatar.src = '/images/icons/profile.png';
    const myProfileLabel = (0, $iqZMU.createElement)('p', null, null);
    myProfileLabel.innerText = 'Log In';
    avatarAndProfile.append(avatar, myProfileLabel);
    (0, $81Clf.makeNewButton)(avatarAndProfile, $b70fc1debd16810b$var$LEFT_SIDE_LABEL_COLOR, 'black', null, 'darken', null);
    if (loginToken !== null) {
        myProfileLabel.innerText = 'My Profile';
        if (username !== null && username !== undefined) {
            avatarAndProfile.href = (0, $7NPUP.SITE_URL) + '/user/page/' + username;
            myProfileLabel.innerText = '@' + username;
        }
        if (name !== null && name !== undefined) myProfileLabel.innerText = name;
        if (profile_pic !== null) avatar.src = profile_pic;
    } else avatarAndProfile.href = '/login';
    elementsList.push(avatarAndProfile);
    const siteContent = (0, $iqZMU.createElement)('div', null, [
        'left-side-content-section'
    ]);
    //---------------feed-------------------------
    const feed = (0, $iqZMU.createElement)('a', 'left-side-contnet-feed', [
        'left-side-content-row'
    ]);
    const feedPic = (0, $iqZMU.createElement)('img', null, null);
    feedPic.src = '/images/icons/feed.png';
    const feedLabel = (0, $iqZMU.createElement)('p', null, null);
    feedLabel.innerText = 'Feed';
    feed.append(feedPic, feedLabel);
    (0, $81Clf.makeNewButton)(feed, $b70fc1debd16810b$var$LEFT_SIDE_LABEL_COLOR, 'black', null, 'darken', null);
    feed.href = '/feed';
    //---------------messages-------------------------
    const messages = (0, $iqZMU.createElement)('a', 'left-side-contnet-messages', [
        'left-side-content-row'
    ]);
    const messagesPic = (0, $iqZMU.createElement)('img', null, null);
    messagesPic.src = '/images/icons/messages.png';
    const messagesLabel = (0, $iqZMU.createElement)('p', null, null);
    messagesLabel.innerText = 'Messages';
    messages.append(messagesPic, messagesLabel);
    (0, $81Clf.makeNewButton)(messages, $b70fc1debd16810b$var$LEFT_SIDE_LABEL_COLOR, 'black', null, 'darken', null);
    messages.href = '/will-appear-soon';
    //---------------About-------------------------
    const aboutTheProject = (0, $iqZMU.createElement)('a', 'left-side-contnet-about', [
        'left-side-content-row'
    ]);
    const aboutTheProjectPic = (0, $iqZMU.createElement)('img', null, null);
    aboutTheProjectPic.src = '/images/icons/about_the_project.png';
    const aboutTheProjectLabel = (0, $iqZMU.createElement)('p', null, null);
    aboutTheProjectLabel.innerText = 'About The Project';
    aboutTheProject.append(aboutTheProjectPic, aboutTheProjectLabel);
    (0, $81Clf.makeNewButton)(aboutTheProject, $b70fc1debd16810b$var$LEFT_SIDE_LABEL_COLOR, 'black', null, 'darken', null);
    aboutTheProject.href = '/about/the-project';
    //---------------Partners-------------------------
    const partners = (0, $iqZMU.createElement)('a', 'left-side-contnet-partners', [
        'left-side-content-row'
    ]);
    const partnersPic = (0, $iqZMU.createElement)('img', null, null);
    partnersPic.src = '/images/icons/handshake.png';
    const partnersLabel = (0, $iqZMU.createElement)('p', null, null);
    partnersLabel.innerText = 'Our partners';
    partners.append(partnersPic, partnersLabel);
    (0, $81Clf.makeNewButton)(partners, $b70fc1debd16810b$var$LEFT_SIDE_LABEL_COLOR, 'black', null, 'darken', null);
    partners.href = '/about/our-partners';
    siteContent.append(feed, messages, aboutTheProject, partners);
    elementsList.push(siteContent);
    //---------------Log Out-------------------------
    if (loginToken != null) {
        const logOutRow = (0, $iqZMU.createElement)('div', 'left-side-contnet-logout', [
            'left-side-content-row'
        ]);
        const logoutPic = (0, $iqZMU.createElement)('img', null, null);
        logoutPic.src = '/images/icons/log_out.png';
        const logoutLabel = (0, $iqZMU.createElement)('p', null, null);
        logoutLabel.innerText = 'Log out';
        logOutRow.append(logoutPic, logoutLabel);
        (0, $81Clf.makeNewButton)(logOutRow, $b70fc1debd16810b$var$LEFT_SIDE_LABEL_COLOR, 'black', null, 'darken', null);
        logOutRow.addEventListener('click', ()=>(0, $5zOzO.logOut)());
        elementsList.push(logOutRow);
    }
    return elementsList;
}
function $b70fc1debd16810b$var$goToLink(link) {
    window.location = link;
}

});

parcelRegister("chUGo", function(module, exports) {

$parcel$export(module.exports, "createPageHeader", () => $8f230a9aa160db1c$export$b080704de21136f);

var $h0dsE = parcelRequire("h0dsE");
parcelRequire("5zOzO");

var $iqZMU = parcelRequire("iqZMU");

var $81Clf = parcelRequire("81Clf");
function $8f230a9aa160db1c$export$b080704de21136f() {
    const header = document.createElement('header');
    const logoAndSearchBar = (0, $iqZMU.createElement)('div', 'header-logo-and-search-bar', null);
    const logoLink = (0, $iqZMU.createElement)('a', 'header-logo-link', null);
    logoLink.href = '/feed';
    const logo = (0, $iqZMU.createElement)('img', null, null);
    logo.src = '/images/logo/logo3_smooth.png';
    logoLink.append(logo);
    const searchBar = document.createElement('div');
    searchBar.setAttribute('id', 'header-search-bar');
    const searchInput = document.createElement('input');
    searchInput.setAttribute('id', 'header-search-input');
    searchInput.placeholder = 'Search...';
    searchInput.addEventListener('keydown', (e)=>{
        if (e.key === 'Enter') (0, $h0dsE.switchToSearchPreviewWindow)(searchInput);
    });
    const searchButton = (0, $iqZMU.createElement)('button', 'header-search-bar-button', null);
    const searchButtonImg = document.createElement('img');
    searchButtonImg.src = '/images/icons/search.png';
    searchButton.addEventListener('click', ()=>(0, $h0dsE.switchToSearchPreviewWindow)(searchInput));
    searchButton.append(searchButtonImg);
    searchBar.append(searchInput);
    searchBar.append(searchButton);
    logoAndSearchBar.append(logoLink);
    logoAndSearchBar.append(searchBar);
    header.append(logoAndSearchBar);
    document.querySelector('body').append(header);
    (0, $81Clf.makeNewButton)(searchButton, 'grey', 'black', null, 'darken');
    return header;
}

});
parcelRegister("h0dsE", function(module, exports) {

$parcel$export(module.exports, "switchToSearchPreviewWindow", () => $c60ce0e0757d01cd$export$55fed7f4cd8e7dcc);
$parcel$export(module.exports, "switchToSearchNodesWindow", () => $c60ce0e0757d01cd$export$5ee536be69c0db30);

var $7NPUP = parcelRequire("7NPUP");
function $c60ce0e0757d01cd$export$55fed7f4cd8e7dcc(searchInput) {
    let searchLine = searchInput.value;
    searchLine = searchLine.replaceAll('+', '%2B');
    searchLine = searchLine.replaceAll(' ', '+');
    window.location = (0, $7NPUP.SITE_URL) + '/search/preview=' + searchLine;
}
function $c60ce0e0757d01cd$export$5ee536be69c0db30(searchInput, page) {
    let searchLine = searchInput.value;
    searchLine = searchLine.replaceAll('+', '%2B');
    searchLine = searchLine.replaceAll(' ', '+');
    window.location = (0, $7NPUP.SITE_URL) + '/search/branches=' + searchLine + '/page=' + page;
}

});


parcelRegister("cCBwI", function(module, exports) {

$parcel$export(module.exports, "insertPlaqueAndAlertWindow", () => $930624afaa0112b7$export$a84005737f7c10da);

var $iqZMU = parcelRequire("iqZMU");

var $81Clf = parcelRequire("81Clf");

var $fKjmJ = parcelRequire("fKjmJ");
function $930624afaa0112b7$export$a84005737f7c10da(text, exit = true) {
    const plaque = (0, $fKjmJ.createPlaque)();
    $930624afaa0112b7$export$bda7b7aa73a27d1d(plaque, text, exit);
    return plaque;
}
function $930624afaa0112b7$export$bda7b7aa73a27d1d(plaque, text, exit = true) {
    const alertWindow = (0, $iqZMU.createElement)('div', 'alert-window', null);
    const alertWindowText = (0, $iqZMU.createElement)('p', null, null);
    alertWindowText.innerText = text;
    const alertWindowButton = (0, $iqZMU.createElement)('button', null, null);
    (0, $81Clf.makeNewButton)(alertWindowButton, 'light-black', 'white', 'Alright', 'lighten');
    alertWindowButton.addEventListener('click', ()=>plaque.remove());
    alertWindow.append(alertWindowText, alertWindowButton);
    plaque.append(alertWindow);
    if (exit === true) plaque.addEventListener('click', (e)=>{
        if (e.target === plaque) plaque.remove();
    });
    alertWindow.alertWindowText = alertWindowText;
    alertWindow.alertWindowButton = alertWindowButton;
    alertWindow.appendToCenter = (element)=>{
        const buttonRemoved = !alertWindow.contains(alertWindowButton);
        if (buttonRemoved) alertWindow.append(element);
        else alertWindowButton.insertAdjacentElement('beforebegin', element);
    };
    plaque.alertWindow = alertWindow;
    return plaque;
}

});
parcelRegister("fKjmJ", function(module, exports) {

$parcel$export(module.exports, "createPlaque", () => $b76a2c7ccf098f6a$export$5f700562da233d6);
$parcel$export(module.exports, "createPlaqueWithQuickExit", () => $b76a2c7ccf098f6a$export$bc2fdabe5bc4d796);

var $31Bjw = parcelRequire("31Bjw");
const $b76a2c7ccf098f6a$var$mainBodyElement = document.querySelector('body');
function $b76a2c7ccf098f6a$export$5f700562da233d6() {
    const plaque = document.createElement('div');
    plaque.setAttribute('id', 'plaque');
    $b76a2c7ccf098f6a$var$mainBodyElement.append(plaque);
    //plaque.addEventListener('click', e => plaquePress(e));
    plaque.makePlaqueQuitToggle = (message, messageCancel, messageConfirm)=>(0, $31Bjw.makePlaqueQuitToggle)(plaque, message, messageCancel, messageConfirm);
    return plaque;
}
function $b76a2c7ccf098f6a$export$bc2fdabe5bc4d796() {
    const plaque = $b76a2c7ccf098f6a$export$5f700562da233d6();
    plaque.addEventListener('click', (e)=>$b76a2c7ccf098f6a$var$plaquePress(e));
    return plaque;
}
function $b76a2c7ccf098f6a$var$plaquePress(e) {
    if (e.target.id === 'plaque') document.getElementById('plaque').remove();
}

});
parcelRegister("31Bjw", function(module, exports) {

$parcel$export(module.exports, "makePlaqueQuitToggle", () => $233e68d45eca3a51$export$33b87ca47ed3a11a);

var $9VVEN = parcelRequire("9VVEN");
function $233e68d45eca3a51$export$33b87ca47ed3a11a(plaque, message, messageCancel, messageConfirm) {
    plaque.quitToggle = false;
    plaque.addEventListener('click', (e)=>$233e68d45eca3a51$var$plaquePressQuitToggle(plaque, message, messageCancel, messageConfirm, e));
}
function $233e68d45eca3a51$var$plaquePressQuitToggle(plaque, message, messageCancel, messageConfirm, e) {
    if (e.target.id === 'plaque') {
        if (!plaque.quitToggle) {
            plaque.quitToggle = true;
            (0, $9VVEN.quitPlaque)(plaque, message, messageCancel, messageConfirm);
        } else if (plaque.quitToggle) {
            plaque.quitToggle = false;
            plaque.querySelector('#quit-plaque-window').remove();
            for (let plaqueChild of plaque.children)plaqueChild.classList.remove('hidden-info');
        }
    }
}

});
parcelRegister("9VVEN", function(module, exports) {

$parcel$export(module.exports, "quitPlaque", () => $73b6296e185a59fe$export$3638c486867946c8);

var $81Clf = parcelRequire("81Clf");
function $73b6296e185a59fe$export$3638c486867946c8(plaque1, message, messageCancel, messageConfirm) {
    if (plaque1.quitToggle !== null) plaque1.quitToggle = true;
    const plaqueChildren = plaque1.children;
    for (let plaqueChild of plaqueChildren)plaqueChild.classList.add('hidden-info');
    const quitPlaqueWindow = document.createElement('div');
    quitPlaqueWindow.setAttribute('id', 'quit-plaque-window');
    const quitText = document.createElement('p');
    quitText.innerText = message;
    const quitButtonGroup = document.createElement('div');
    const quitCancelButton = document.createElement('button');
    const quitConfirmButton = document.createElement('button');
    quitPlaqueWindow.append(quitText);
    quitPlaqueWindow.append(quitButtonGroup);
    quitButtonGroup.append(quitCancelButton);
    quitButtonGroup.append(quitConfirmButton);
    plaque1.append(quitPlaqueWindow);
    (0, $81Clf.makeNewButton)(quitCancelButton, 'light-black', 'white', messageCancel, 'lighten');
    quitCancelButton.addEventListener('click', ()=>$73b6296e185a59fe$var$quitCancel(quitPlaqueWindow, plaqueChildren));
    (0, $81Clf.makeNewButton)(quitConfirmButton, 'grey', 'black', messageConfirm, 'darken');
    quitConfirmButton.addEventListener('click', ()=>$73b6296e185a59fe$var$quitConfirm(plaque1));
}
function $73b6296e185a59fe$var$quitCancel(quitWindow, plaqueChildren) {
    if (plaque.quitToggle !== null) plaque.quitToggle = false;
    quitWindow.remove();
    for (let plaqueChild of plaqueChildren)plaqueChild.classList.remove('hidden-info');
}
function $73b6296e185a59fe$var$quitConfirm(plaque1) {
    plaque1.remove();
}

});




parcelRegister("lz1lC", function(module, exports) {

$parcel$export(module.exports, "ParamValidator", () => $fb2de9792582319d$export$4f477fde8fc82c31);
$parcel$export(module.exports, "ValidationError", () => $fb2de9792582319d$export$2191b9da168c6cf0);
// paramValidator.js
const $fb2de9792582319d$export$4f477fde8fc82c31 = {
    MAX_LINK_LENGTH: 2048,
    MIN_LINK_LENGTH: 10,
    SAFE_TEXT_PATTERN: /^[\p{L}\p{N}\p{P}\p{Zs}\p{So}]*$/u,
    SAFE_TEXT_PATTERN_EXPANDED: /^[\p{L}\p{N}\p{P}\p{Zs}\p{So}\r\n\t]*$/u,
    LINK_SYMBOLS: /^https?:\/\/[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}.*$/,
    USERNAME_PATTERN: /^[A-Za-z0-9_]{4,25}$/,
    BANNED_PASSWORD_CHARS_REGEX: /[^\x21-\x7E]/,
    EMAIL_PATTERN: /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/,
    isNullOrBlank (str) {
        return str == null || str.trim() === '';
    },
    basicSanitize (input) {
        if (input == null) return null;
        return this.stripControlChars(input.trim());
    },
    stripControlChars (input) {
        if (input == null) return null;
        // Keep \n, \r, and \t as harmless
        return input.replace(/[\x00-\x08\x0B\x0C\x0E-\x1F\x7F]/g, ''); // note: JS uses different regex rules
    },
    normalizeLink (link) {
        if (!link || typeof link !== 'string') return null;
        // Trim whitespace and remove invisible control characters
        link = link.trim().replace(/[\x00-\x1F\x7F]/g, '');
        // Empty after cleaning?
        if (!link) return null;
        // If the user forgot the protocol, assume HTTPS
        if (!/^[a-zA-Z][a-zA-Z\d+\-.]*:\/\//.test(link)) link = `https://${link}`;
        try {
            const url = new URL(link);
            // Normalize hostname (lowercase, strip default ports)
            url.hostname = url.hostname.toLowerCase();
            if (url.protocol === 'http:' && url.port === '80' || url.protocol === 'https:' && url.port === '443') url.port = '';
            // Remove trailing slash if no path beyond domain
            if (url.pathname === '/') url.pathname = '';
            // Return normalized absolute URL
            return url.toString();
        } catch (e) {
            // Invalid URL
            return null;
        }
    },
    isValidLink (link) {
        if (this.isNullOrBlank(link)) return false;
        if (link.length > this.MAX_LINK_LENGTH) return false;
        if (!/^https?:\/\//.test(link)) return false;
        if (!this.LINK_SYMBOLS.test(link)) return false;
        try {
            new URL(link);
        } catch (e) {
            return false;
        }
        return true;
    },
    isSafeTextNullable (text, maxLength) {
        if (this.isNullOrBlank(text)) return true;
        if (text.length > maxLength) return false;
        return this.SAFE_TEXT_PATTERN.test(text);
    },
    isValidText (text, maxLength) {
        if (this.isNullOrBlank(text)) return false;
        if (text.length > maxLength) return false;
        return this.SAFE_TEXT_PATTERN.test(text);
    },
    isSafeTextNullableExpanded (text, maxLength) {
        if (this.isNullOrBlank(text)) return true;
        if (text.length > maxLength) return false;
        return this.SAFE_TEXT_PATTERN_EXPANDED.test(text);
    },
    isValidTextExpanded (text, maxLength) {
        if (this.isNullOrBlank(text)) return false;
        if (text.length > maxLength) return false;
        return this.SAFE_TEXT_PATTERN_EXPANDED.test(text);
    },
    isValidUsername (username) {
        if (this.isNullOrBlank(username)) return false;
        return this.USERNAME_PATTERN.test(username);
    },
    isValidPassword (password) {
        if (this.isNullOrBlank(password)) return false;
        if (password.length > 40) return false;
        return !this.BANNED_PASSWORD_CHARS_REGEX.test(password);
    },
    isValidStorageFileLink (storageLink) {
        if (this.isNullOrBlank(storageLink)) return false;
        return storageLink.length < 200;
    },
    isValidYoutubeVideoId (videoId) {
        if (this.isNullOrBlank(videoId)) return false;
        if (typeof videoId !== 'string') return false;
        return videoId.length < 20;
    },
    isValidSoundCloudTrackId (trackId) {
        if (this.isNullOrBlank(trackId)) return false;
        if (typeof trackId !== 'string') return false;
        return trackId.length < 20;
    },
    isValidEmail (email) {
        if (this.isNullOrBlank(email)) return false;
        if (email.length < 6 || email.length > 254) return false;
        if (/[^\S\r\n\t]/.test(email)) return false; // disallow spaces
        return this.EMAIL_PATTERN.test(email);
    }
};
class $fb2de9792582319d$export$2191b9da168c6cf0 extends Error {
    constructor(message){
        super(message);
        this.name = "ValidationError";
    }
}

});

parcelRegister("f02AW", function(module, exports) {

$parcel$export(module.exports, "createRequestObject", () => $aeb8de5d10de8219$export$eb72a595ee4943bf);

var $02lEP = parcelRequire("02lEP");

var $7NPUP = parcelRequire("7NPUP");
parcelRequire("cCBwI");
function $aeb8de5d10de8219$export$eb72a595ee4943bf() {
    const hiddenVariables = {
        rootUrl: null,
        url: null,
        searchParams: {},
        method: null,
        headers: {},
        body: null,
        processIfCaptchaRequired: true
    };
    const statusFunctions = {};
    const requestObject = {};
    statusFunctions['captcha'] = ()=>$aeb8de5d10de8219$var$responseStatusFunctionCaptcha(requestObject);
    requestObject.setURL = (url)=>$aeb8de5d10de8219$var$setURL(hiddenVariables, url, requestObject);
    requestObject.setRootURL = (url)=>$aeb8de5d10de8219$var$setRootURL(hiddenVariables, url, requestObject);
    requestObject.addSearchParam = (paramName, paramValue)=>$aeb8de5d10de8219$var$addSearchParam(hiddenVariables, paramName, paramValue, requestObject);
    requestObject.setMethod = (method)=>$aeb8de5d10de8219$var$setMethod(hiddenVariables, method, requestObject);
    requestObject.addHeader = (headerName, headerValue)=>$aeb8de5d10de8219$var$addHeader(hiddenVariables, headerName, headerValue, requestObject);
    requestObject.setBodyJsonFromObject = (objectToAdd)=>$aeb8de5d10de8219$var$setBodyJsonFromObject(hiddenVariables, objectToAdd, requestObject);
    requestObject.setBodyFormData = (formData)=>$aeb8de5d10de8219$var$setBodyFormData(hiddenVariables, formData, requestObject);
    requestObject.executeRequest = ()=>$aeb8de5d10de8219$var$executeRequest(hiddenVariables, statusFunctions);
    requestObject.onResponseStatus = (responseStatus, callback)=>$aeb8de5d10de8219$var$onResponseStatus(statusFunctions, responseStatus, callback, requestObject);
    for(let i = 1; i <= 5; i++)requestObject[`onResponseStatus${i}xx`] = (callback)=>$aeb8de5d10de8219$var$onResponsexxx(statusFunctions, i, callback, requestObject);
    requestObject.onResponseElse = (callback)=>$aeb8de5d10de8219$var$onResponseElse(statusFunctions, callback, requestObject);
    requestObject.onResponseError = (callback)=>$aeb8de5d10de8219$var$onResponseError(statusFunctions, callback, requestObject);
    return requestObject;
}
function $aeb8de5d10de8219$var$setURL(hiddenVariables, url, requestObject) {
    hiddenVariables.url = url;
    return requestObject;
}
function $aeb8de5d10de8219$var$setRootURL(hiddenVariables, rootUrl, requestObject) {
    hiddenVariables.rootUrl = rootUrl;
    if (hiddenVariables.url === null || hiddenVariables.url === undefined) hiddenVariables.url = "";
    return requestObject;
}
function $aeb8de5d10de8219$var$addSearchParam(hiddenVariables, paramName, paramValue, requestObject) {
    hiddenVariables.searchParams[paramName] = paramValue;
    return requestObject;
}
function $aeb8de5d10de8219$var$setMethod(hiddenVariables, method, requestObject) {
    hiddenVariables.method = method;
    return requestObject;
}
function $aeb8de5d10de8219$var$addHeader(hiddenVariables, headerName, headerValue, requestObject) {
    hiddenVariables.headers[headerName] = headerValue;
    return requestObject;
}
function $aeb8de5d10de8219$var$setBodyJsonFromObject(hiddenVariables, objectToAdd, requestObject) {
    hiddenVariables.body = JSON.stringify(objectToAdd);
    hiddenVariables.headers['Content-Type'] = "application/json";
    return requestObject;
}
function $aeb8de5d10de8219$var$setBodyFormData(hiddenVariables, formData, requestObject) {
    hiddenVariables.body = formData;
    return requestObject;
}
async function $aeb8de5d10de8219$var$executeRequest(hiddenVariables, statusFunctions) {
    const requestInfo = {
        method: hiddenVariables.method
    };
    if (hiddenVariables.rootUrl === null || hiddenVariables.rootUrl === undefined) hiddenVariables.rootUrl = (0, $7NPUP.API_GATEWAY_NOSLASH);
    const url = new URL(hiddenVariables.rootUrl + hiddenVariables.url);
    const searchParams = hiddenVariables.searchParams;
    if (searchParams !== null) for (const [paramName, paramValue] of Object.entries(searchParams))url.searchParams.append(paramName, paramValue);
    /*
    const awsCaptchaToken = checkCaptchaToken();
    if(awsCaptchaToken!==null)
        addHeader(hiddenVariables, 'x-amzn-waf-captcha-token', awsCaptchaToken, null);
    */ if (Object.entries(hiddenVariables.headers).length > 0) requestInfo.headers = hiddenVariables.headers;
    console.log("request headers: ", requestInfo.headers);
    const body = hiddenVariables.body;
    if (body !== null && body !== undefined) requestInfo.body = body;
    try {
        const response = await fetch(url, requestInfo);
        const responseStatusFunctionCaptcha = statusFunctions['captcha'];
        const responseStatusFunction = statusFunctions[response.status];
        const responseStatusFunctionFTypeDefault = statusFunctions[$aeb8de5d10de8219$var$getStatusFirstNumber(response.status)]; //for 1xx, 2xx, 3xx, etc.
        const responseStatusFunctionElse = statusFunctions['else'];
        if (response.headers.get("x-amzn-waf-action") === "captcha" && hiddenVariables.processIfCaptchaRequired === true) return responseStatusFunctionCaptcha();
        else if (responseStatusFunction !== null && responseStatusFunction !== undefined) return responseStatusFunction(response);
        else if (responseStatusFunctionFTypeDefault !== null && responseStatusFunctionFTypeDefault !== undefined) return responseStatusFunctionFTypeDefault(response);
        else if (responseStatusFunctionElse !== null && responseStatusFunctionElse !== undefined) return responseStatusFunctionElse(response);
    } catch (error) {
        const responseStatusError = statusFunctions['error'];
        if (responseStatusError !== null && responseStatusError !== undefined) responseStatusError();
        else throw error;
    }
}
function $aeb8de5d10de8219$var$onResponseStatus(statusFunctions, responseStatus, callback, requestObject) {
    if (!(callback instanceof Function)) throw new Error(`${callback} is not a function!`);
    statusFunctions[responseStatus] = callback;
    return requestObject;
}
function $aeb8de5d10de8219$var$onResponsexxx(statusFunctions, number, callback, requestObject) {
    if (!(callback instanceof Function)) throw new Error(`${callback} is not a function!`);
    statusFunctions[`${number}xx`] = callback;
    return requestObject;
}
function $aeb8de5d10de8219$var$onResponseElse(statusFunctions, callback, requestObject) {
    if (!(callback instanceof Function)) throw new Error(`${callback} is not a function!`);
    statusFunctions['else'] = callback;
    return requestObject;
}
function $aeb8de5d10de8219$var$onResponseError(statusFunctions, callback, requestObject) {
    if (!(callback instanceof Function)) throw new Error(`${callback} is not a function!`);
    statusFunctions['error'] = callback;
    return requestObject;
}
function $aeb8de5d10de8219$var$getStatusFirstNumber(status) {
    const firstDigit = Math.floor(status / 100);
    return `${firstDigit}xx`;
}
async function $aeb8de5d10de8219$var$responseStatusFunctionCaptcha(requestObject) {
    let resolver, rejecter;
    // Define the promise first
    const captchaPromise = new Promise((resolve, reject)=>{
        resolver = resolve;
        rejecter = reject;
    });
    const CaptchaWindowOnPlaque = await (0, $02lEP.createCaptchaWindowWithPlaque)(async (captchaToken)=>{
        console.log("Captcha check: retry function ", captchaToken);
        const captchaTokenObject = {
            captchaTokenValue: captchaToken,
            expiry: Date.now() + 300000
        };
        localStorage.setItem('aws_captcha_token', JSON.stringify(captchaTokenObject));
        const retryResponse = await requestObject.executeRequest();
        resolver(retryResponse);
    }, (err)=>{
        rejecter(err);
        console.log("Captcha error", err);
    });
    return captchaPromise;
}
function $aeb8de5d10de8219$var$checkCaptchaToken() {
    const raw = localStorage.getItem('aws_captcha_token');
    if (!raw) return null;
    try {
        const captchaTokenObject = JSON.parse(raw);
        if (captchaTokenObject !== null && captchaTokenObject !== undefined) {
            if (Date.now() < captchaTokenObject.expiry) return captchaTokenObject.captchaTokenValue;
            else {
                localStorage.removeItem('aws_captcha_token');
                return null;
            }
        }
    } catch (err) {
        console.error("Invalid captcha token in storage", err);
        localStorage.removeItem('aws_captcha_token');
        return null;
    }
}

});
parcelRegister("02lEP", function(module, exports) {

$parcel$export(module.exports, "createCaptchaWindowWithPlaque", () => $0070fcbcaaa761ee$export$84c103be3bbce89b);

var $fKjmJ = parcelRequire("fKjmJ");

var $iqZMU = parcelRequire("iqZMU");
function $0070fcbcaaa761ee$var$checkResponseForCaptchaAndDisplay(response, retryFunction) {
    if (response.status === 405 && response.headers.get("x-amzn-waf-action") === "captcha") $0070fcbcaaa761ee$export$84c103be3bbce89b(retryFunction);
}
function $0070fcbcaaa761ee$var$createCaptchaWindow(retryFunction, onError) {
    const captchaWindow = (0, $iqZMU.createElement)('div', null, [
        'captcha-window'
    ]);
    AwsWafCaptcha.renderCaptcha(captchaWindow, {
        apiKey: 'q5APhgLdk3+48n9N4GN82RM7q8ZJLWYSB+6yfWrPcLMNj6HxyDYxhYMMu/HQrn/FL+lgOO6Ppdu8oGfuhCnIRn61xftfo2nbTxXHuDsEoWM4HhmjGaJIMNARI2EeRJ6Kqy0nHjRV7vd2hEKGlDJW8wTpovbU2IYOBSzDWByJUFoBjEovIJ72i9g5EHzSsBQ9eFZDO8AbUEQ9FV/Hfxuj57YUWe1FZqmfUkT3fI9sfOru2lvoFQLzF5wBy7TUluqTGEEojYhENmxOd6Sdoot2UWYTzeGeLqQoexAMiKvbUZo6u2HD4EwRIGR/zDIOjckzPwDde6whY0eoe8NzPk+NtPps5tvHXUqUZzVMTLCng7xkSn5Y3craXAua3dtbtaCN2Mjyz37Ktas6nDHRrStFxMVrwAPgUhdfgNAEIsayFhNBt0NAJxGmIcUdENYCrkx+NOGhofRjvRLKfk2iAYmj0ka2l5N8QH2aspyp7FVNktOP1MDHWPxruJ5A6kg85yyHXxsgxqcQ8TSth8bIgSmIhzBQwGSaK5h18M2hfBrq+ojBAQ1k2r+uex4P9kCrd0Zl15KFKoaGYKBH9v38oQkGte3PtPp/6vIJcowuCap9JNc9YzmD6ZwJsWM32X3FKGFt40XBvteCE2Ji4yR11FscrD6VuZ0lZ3wDGuEXX5bBi5I=_1_1',
        onSuccess: (captchaToken)=>retryFunction(captchaToken),
        onError: (err)=>onError(err)
    });
    return captchaWindow;
}
function $0070fcbcaaa761ee$export$84c103be3bbce89b(retryFunction, onError) {
    const plaque = (0, $fKjmJ.createPlaque)();
    plaque.makePlaqueQuitToggle('Abort the challenge?', 'No', 'Yes');
    const captchaWindow = $0070fcbcaaa761ee$var$createCaptchaWindow((captchaToken)=>{
        retryFunction(captchaToken);
        plaque.remove();
    }, (err)=>{
        onError(err);
    });
    plaque.append(captchaWindow);
    return plaque;
}

});


parcelRegister("3nR07", function(module, exports) {

$parcel$export(module.exports, "MAX_FILE_SIZE_MB", () => $276ca1f1b16b9e11$export$bc7aff856d242a38);
$parcel$export(module.exports, "MAX_NAME_LENGTH", () => $276ca1f1b16b9e11$export$cd2b108cbcd37452);
$parcel$export(module.exports, "createFileChecker", () => $276ca1f1b16b9e11$export$6658cacd16253de1);
const $276ca1f1b16b9e11$export$bc7aff856d242a38 = 5;
const $276ca1f1b16b9e11$export$cd2b108cbcd37452 = 100;
const $276ca1f1b16b9e11$var$maxFileSize = $276ca1f1b16b9e11$export$bc7aff856d242a38 * 1048576; // 5 MB
const $276ca1f1b16b9e11$var$allowedExtensions = {
    'branch_picture': [
        'jpg',
        'jpeg',
        'png',
        'gif'
    ],
    'profile_picture': [
        'jpg',
        'jpeg',
        'png'
    ]
};
const $276ca1f1b16b9e11$var$namePattern = /^[^\\/<>:"|?*\x00-\x1F\x7F]+$/u;
function $276ca1f1b16b9e11$export$6658cacd16253de1() {
    const fileChecker = {};
    const fileCheckerFunctions = {
        'size-limit': null,
        'wrong-format': null,
        'long-name': null,
        'improper-name': null,
        'universal': null
    };
    let filePurpose = null;
    fileChecker.onSizeLimit = (callback)=>$276ca1f1b16b9e11$var$onStatus(fileCheckerFunctions, 'size-limit', callback);
    fileChecker.onWrongFormat = (callback)=>$276ca1f1b16b9e11$var$onStatus(fileCheckerFunctions, 'wrong-format', callback);
    fileChecker.onLongName = (callback)=>$276ca1f1b16b9e11$var$onStatus(fileCheckerFunctions, 'long-name', callback);
    fileChecker.onImproperName = (callback)=>$276ca1f1b16b9e11$var$onStatus(fileCheckerFunctions, 'improper-name', callback);
    fileChecker.setUniversalStatus = (callback)=>$276ca1f1b16b9e11$var$onStatus(fileCheckerFunctions, 'universal', callback);
    fileChecker.setFilePurpose = (filePurposeValue)=>{
        filePurpose = filePurposeValue;
    };
    fileChecker.checkFile = (file)=>$276ca1f1b16b9e11$var$checkFile(fileCheckerFunctions, filePurpose, file);
    return fileChecker;
}
function $276ca1f1b16b9e11$var$checkFile(fileCheckerFunctions, filePurpose, file) {
    if (!(file instanceof File)) return false;
    const fileName = file.name;
    const fileSize = file.size; // in bytes
    const extension = fileName.split('.').pop().toLowerCase();
    const universalFunction = fileCheckerFunctions['universal'];
    let valid = true;
    if (fileSize > $276ca1f1b16b9e11$var$maxFileSize) {
        valid = false;
        const sizeLimitFunc = fileCheckerFunctions['size-limit'];
        if (sizeLimitFunc) sizeLimitFunc($276ca1f1b16b9e11$export$bc7aff856d242a38);
        else if (universalFunction) universalFunction(`Your file is too large. It has to be below ${$276ca1f1b16b9e11$export$bc7aff856d242a38}MB`);
    }
    if (!$276ca1f1b16b9e11$var$checkExtensions(filePurpose, extension)) {
        valid = false;
        const extensionFunc = fileCheckerFunctions['wrong-format'];
        if (extensionFunc) extensionFunc(extension);
        else if (universalFunction) universalFunction(`Your file format ".${extension}" is not supported.`);
    }
    if (fileName.length > $276ca1f1b16b9e11$export$cd2b108cbcd37452) {
        valid = false;
        const fileNameLengthFunc = fileCheckerFunctions['long-name'];
        if (fileNameLengthFunc) fileNameLengthFunc($276ca1f1b16b9e11$export$cd2b108cbcd37452);
        else if (universalFunction) universalFunction(`Your file name exceeds ${$276ca1f1b16b9e11$export$cd2b108cbcd37452} characters.`);
    }
    const normalized = fileName.normalize('NFC');
    if (!$276ca1f1b16b9e11$var$namePattern.test(normalized)) {
        valid = false;
        const filenamePatternFunc = fileCheckerFunctions['improper-name'];
        if (filenamePatternFunc) filenamePatternFunc();
        else if (universalFunction) universalFunction(`Your file name contains invalid characters.`);
    }
    return valid;
}
function $276ca1f1b16b9e11$var$onStatus(fileCheckerFunctions, status, callback) {
    if (!(callback instanceof Function)) throw new Error(`${callback} is not a function!`);
    fileCheckerFunctions[status] = callback;
}
function $276ca1f1b16b9e11$var$checkExtensions(filePurpose, extension) {
    const extensionsArray = $276ca1f1b16b9e11$var$allowedExtensions[filePurpose];
    if (!extensionsArray) throw new Error(`Unknown file purpose: ${filePurpose}`);
    return extensionsArray.includes(extension);
}

});


var $a5iko = parcelRequire("a5iko");
parcelRequire("4V6Ya");

var $4V6Ya = parcelRequire("4V6Ya");

var $9lyWO = parcelRequire("9lyWO");

var $7NPUP = parcelRequire("7NPUP");
const $a9885ba3a161830f$var$mode = {
    'post-like': {
        background: (0, $9lyWO.GREY_BUTTON_COLOR),
        color: 'black',
        innerText: 'Like',
        eventFunction: $a9885ba3a161830f$var$postLike,
        backgroundColorInteractions: (0, $4V6Ya.darkenButtonInteractions)
    },
    'post-dislike': {
        background: (0, $9lyWO.GREY_BUTTON_COLOR),
        color: 'black',
        innerText: 'Dislike',
        eventFunction: $a9885ba3a161830f$var$postDislike,
        backgroundColorInteractions: (0, $4V6Ya.darkenButtonInteractions)
    },
    'delete-like': {
        background: (0, $9lyWO.ROYAL_BLUE_COLOR),
        color: 'white',
        innerText: 'Liked',
        eventFunction: $a9885ba3a161830f$var$deleteLike,
        backgroundColorInteractions: (0, $4V6Ya.lightenButtonInteractions)
    },
    'delete-dislike': {
        background: (0, $9lyWO.RED_BUTTON_COLOR),
        color: 'white',
        innerText: 'Disliked',
        eventFunction: $a9885ba3a161830f$var$deleteDislike,
        backgroundColorInteractions: (0, $4V6Ya.lightenButtonInteractions)
    }
};
function $a9885ba3a161830f$export$729aa8c1950f8c37(nodeId, element, modeValue) {
    const modeObject = $a9885ba3a161830f$var$mode[modeValue];
    const newElement = element.cloneNode(true);
    newElement.style.background = modeObject.background;
    newElement.style.color = modeObject.color;
    newElement.innerText = modeObject.innerText;
    newElement.addEventListener('click', ()=>modeObject.eventFunction(nodeId, newElement));
    element.replaceWith(newElement);
    modeObject.backgroundColorInteractions(newElement);
}
async function $a9885ba3a161830f$var$postLike(nodeId, element) {
    const response = await fetch((0, $7NPUP.API_GATEWAY) + "likes/post/like/" + nodeId, {
        method: "POST",
        headers: {
            "Token-Auth": `${localStorage.branchof_access_token}`
        }
    });
    if (response.status === 200) {
        $a9885ba3a161830f$var$switchAnotherButton(nodeId, element, 'post-dislike');
        $a9885ba3a161830f$export$729aa8c1950f8c37(nodeId, element, 'delete-like');
    }
}
async function $a9885ba3a161830f$var$postDislike(nodeId, element) {
    const response = await fetch((0, $7NPUP.API_GATEWAY) + "likes/post/dislike/" + nodeId, {
        method: "POST",
        headers: {
            "Token-Auth": `${localStorage.branchof_access_token}`
        }
    });
    if (response.status === 200) {
        $a9885ba3a161830f$var$switchAnotherButton(nodeId, element, 'post-like');
        $a9885ba3a161830f$export$729aa8c1950f8c37(nodeId, element, 'delete-dislike');
    }
}
async function $a9885ba3a161830f$var$deleteLike(nodeId, element) {
    const response = await fetch((0, $7NPUP.API_GATEWAY) + "likes/delete/" + nodeId, {
        method: "DELETE",
        headers: {
            "Token-Auth": `${localStorage.branchof_access_token}`
        }
    });
    if (response.status === 200) $a9885ba3a161830f$export$729aa8c1950f8c37(nodeId, element, 'post-like');
}
async function $a9885ba3a161830f$var$deleteDislike(nodeId, element) {
    const response = await fetch((0, $7NPUP.API_GATEWAY) + "likes/delete/" + nodeId, {
        method: "DELETE",
        headers: {
            "Token-Auth": `${localStorage.branchof_access_token}`
        }
    });
    if (response.status === 200) $a9885ba3a161830f$export$729aa8c1950f8c37(nodeId, element, 'post-dislike');
}
function $a9885ba3a161830f$var$switchAnotherButton(nodeId, element, modeValue) {
    const otherElements = element.parentNode.children;
    for (let anotherElement of otherElements)if (anotherElement !== element) $a9885ba3a161830f$export$729aa8c1950f8c37(nodeId, anotherElement, modeValue);
}



var $aaNRX = parcelRequire("aaNRX");

var $7NPUP = parcelRequire("7NPUP");
parcelRequire("eOEAK");
parcelRequire("25dWo");

var $5ZqHF = parcelRequire("5ZqHF");

var $iqZMU = parcelRequire("iqZMU");

var $5ZiIO = parcelRequire("5ZiIO");

var $81Clf = parcelRequire("81Clf");

var $2uBUx = parcelRequire("2uBUx");
//----------------------------------------------------------------------------Importing modules end here------------------------------------------------------------------------------
const $039319c8bf8150c3$var$fileMethods = {
    "jpeg": $039319c8bf8150c3$var$imageFileMethodInit,
    "png": $039319c8bf8150c3$var$imageFileMethodInit,
    "avif": $039319c8bf8150c3$var$imageFileMethodInit,
    "gif": $039319c8bf8150c3$var$imageFileMethodInit,
    "tiff": $039319c8bf8150c3$var$imageFileMethodInit,
    "webp": $039319c8bf8150c3$var$imageFileMethodInit,
    "pdf": $039319c8bf8150c3$var$pdfFileMethodInit
};
async function $039319c8bf8150c3$export$4084c9ec4b0e2fec(nodeId, nodeObject, authorInfo, likeStatus) {
    const nodeInfo = (0, $iqZMU.createElement)('section', 'branch-info', null);
    console.log("Here is the nodeObject", nodeObject);
    const previewSection = (0, $iqZMU.createElement)('section', 'content-preview', [
        'node-info-section'
    ]);
    const nameSection = (0, $iqZMU.createElement)('section', 'name', [
        'node-info-section'
    ]);
    const dateAndButtonsSection = (0, $iqZMU.createElement)('section', 'date-and-buttons', [
        'node-info-section'
    ]);
    const resourcesSection = (0, $iqZMU.createElement)('section', 'resources', [
        'node-info-section'
    ]);
    const descriptionSection = (0, $iqZMU.createElement)('section', 'description', [
        'node-info-section'
    ]);
    const tagsSection = (0, $iqZMU.createElement)('section', 'tags', [
        'node-info-section'
    ]);
    $039319c8bf8150c3$var$insertPreview(previewSection, nodeObject.preview);
    $039319c8bf8150c3$var$insertName(nameSection, nodeObject.name);
    $039319c8bf8150c3$var$insertDateAndButtons(nodeId, dateAndButtonsSection, nodeObject.date);
    //insertAuthor(authorSection, nodeObject.author);
    $039319c8bf8150c3$var$insertResources(nodeId, resourcesSection, nodeObject.resources, likeStatus);
    $039319c8bf8150c3$var$insertDescription(descriptionSection, nodeObject.description);
    $039319c8bf8150c3$var$insertTagsAsTextLine(tagsSection, nodeObject.tags);
    nodeInfo.append(previewSection);
    nodeInfo.append(nameSection);
    nodeInfo.append(dateAndButtonsSection);
    nodeInfo.append(resourcesSection);
    nodeInfo.append(descriptionSection);
    nodeInfo.append(tagsSection);
    nodeInfo.onRender = ()=>{
        $039319c8bf8150c3$var$resourcesRender(resourcesSection, resourcesSection.buttonsGroup);
    };
    const nodeElements = [];
    nodeElements.push(nodeInfo);
    return nodeElements;
}
//-------------------------Node set-up functions-------------------------------------------------
//-------------------------Preview Functions-----------------------------------------------------
function $039319c8bf8150c3$var$insertPreview(previewSection, preview) {
    const previewElement = (0, $5ZiIO.createPreview)(preview);
    previewSection.append(previewElement);
}
function $039319c8bf8150c3$var$youtubeMethodInit(previewUrl) {
    const previewContent = document.createElement('iframe');
    previewContent.setAttribute("id", "youtube-preview-content");
    previewContent.src = previewUrl;
    return previewContent;
}
function $039319c8bf8150c3$var$soundCloudMethodInit(previewUrl) {
    const previewContent = document.createElement('iframe');
    previewContent.setAttribute("id", "soundcloud-preview-content");
    previewContent.src = previewUrl;
    return previewContent;
}
function $039319c8bf8150c3$var$imageFileMethodInit(previewPath) {}
function $039319c8bf8150c3$var$pdfFileMethodInit(previewPath) {}
//------------------------------------------------------------------------------------------------------
function $039319c8bf8150c3$var$insertName(nameSection, name) {
    const nameLabel = document.createElement('h2');
    nameLabel.innerText = name;
    nameSection.append(nameLabel);
}
function $039319c8bf8150c3$var$insertDateAndButtons(nodeId, dateAndButtonsSection, date) {
    const dateInfo = document.createElement('p');
    console.log("here is your date " + date + " " + Date.parse(date));
    const newDate = new Date(Date.parse(date));
    const month = new Intl.DateTimeFormat("en-US", {
        month: 'long'
    }).format(newDate);
    dateInfo.innerText = month + " " + newDate.getDate() + ", " + newDate.getFullYear();
    console.log("Get month " + month);
    const branchItButton = document.createElement('button');
    branchItButton.innerText = 'Branch it!';
    branchItButton.setAttribute('id', 'branch-button');
    (0, $81Clf.makeNewButton)(branchItButton, 'light-black', 'white', null, 'lighten');
    const loggedInButtons = [];
    const reactionButton = document.createElement('button');
    reactionButton.innerText = "React";
    loggedInButtons.push(reactionButton);
    const awardButton = document.createElement('button');
    awardButton.innerText = "Award";
    loggedInButtons.push(awardButton);
    let repostButton = document.createElement('button');
    repostButton.innerText = "Repost";
    loggedInButtons.push(repostButton);
    const buttonsGroup = document.createElement('div');
    buttonsGroup.setAttribute('id', 'buttons-group');
    buttonsGroup.append(branchItButton);
    const loginToken = localStorage.getItem("branchof_access_token");
    if (loginToken !== null && loginToken !== undefined) {
        buttonsGroup.append(...loggedInButtons);
        for (let button of loggedInButtons)(0, $81Clf.makeNewButton)(button, 'grey', 'black', null, 'darken');
    }
    buttonsGroup.append(reactionButton);
    buttonsGroup.append(awardButton);
    repostButton = (0, $aaNRX.makeElementRepostButton)(repostButton, nodeId);
    branchItButton.addEventListener('click', ()=>(0, $a5iko.default)(nodeId));
    dateAndButtonsSection.append(dateInfo);
    dateAndButtonsSection.append(buttonsGroup);
}
function $039319c8bf8150c3$var$insertResources(nodeId, resourceSection, resources, likeStatus) {
    if (resources === null || resources.length === 0) {
        const noResourcesCaption = (0, $iqZMU.createElement)('p', 'no-resources-caption', null);
        noResourcesCaption.innerText = 'The author provided no resources for this branch...';
        resourceSection.append(noResourcesCaption);
        return null;
    }
    for (let resourceInfo of resources){
        const resource = (0, $iqZMU.createElement)('div', null, [
            'resource-link-and-commentary'
        ]);
        const resourceLink = document.createElement('a');
        resourceLink.href = (0, $2uBUx.wrapLinkInSafeRedirect)(resourceInfo.link);
        resourceLink.innerText = resourceInfo.link;
        resourceLink.target = '_blank';
        resourceLink.classList.add('resource-link');
        const resourceComment = document.createElement('p');
        resourceComment.innerText = '- ' + resourceInfo.commentary;
        resourceComment.classList.add('resource-comment');
        resource.append(resourceLink);
        resource.append(resourceComment);
        resourceSection.append(resource);
    }
    //----------------------------Button------------------------------
    const buttonsGroup = document.createElement('div');
    buttonsGroup.setAttribute('id', 'resources-buttons-group');
    const buttonLike = document.createElement('button');
    buttonLike.setAttribute('id', 'resources-like-button');
    buttonLike.innerText = 'Like';
    const buttonDislike = document.createElement('button');
    buttonDislike.setAttribute('id', 'resources-dislike-button');
    buttonDislike.innerText = 'Dislike';
    buttonsGroup.append(buttonLike);
    buttonsGroup.append(buttonDislike);
    resourceSection.buttonsGroup = buttonsGroup;
    resourceSection.append(buttonsGroup);
    if (likeStatus == null) {
        (0, $a9885ba3a161830f$export$729aa8c1950f8c37)(nodeId, buttonLike, 'post-like');
        (0, $a9885ba3a161830f$export$729aa8c1950f8c37)(nodeId, buttonDislike, 'post-dislike');
    } else if (likeStatus === true) {
        (0, $a9885ba3a161830f$export$729aa8c1950f8c37)(nodeId, buttonLike, 'delete-like');
        (0, $a9885ba3a161830f$export$729aa8c1950f8c37)(nodeId, buttonDislike, 'post-dislike');
    } else {
        (0, $a9885ba3a161830f$export$729aa8c1950f8c37)(nodeId, buttonLike, 'post-like');
        (0, $a9885ba3a161830f$export$729aa8c1950f8c37)(nodeId, buttonDislike, 'delete-dislike');
    }
}
function $039319c8bf8150c3$var$resourcesRender(resourceSection, buttonsGroup) {
    const allResourceLinks = resourceSection.querySelectorAll('.resource-link-and-commentary');
    if (allResourceLinks.length > 0) {
        const lastLinkElement = allResourceLinks[allResourceLinks.length - 1];
        console.log("resourceSection ", resourceSection);
        console.log("lastLinkElement ", lastLinkElement);
        console.log("buttonsGroup ", buttonsGroup);
        const csContainer = getComputedStyle(resourceSection);
        const csLast = getComputedStyle(lastLinkElement);
        const buttonsGroupStyle = getComputedStyle(buttonsGroup);
        // parent padding (rendered)
        const paddingLeft = parseFloat(csContainer.paddingLeft);
        const paddingRight = parseFloat(csContainer.paddingRight);
        const paddingBottom = parseFloat(csContainer.paddingBottom);
        // last link margins (rendered)
        const marginLeft = parseFloat(csLast.marginLeft);
        const marginRight = parseFloat(csLast.marginRight);
        // widths
        const parentWidth = resourceSection.clientWidth; // inside padding
        const lastWidth = [
            ...lastLinkElement.children
        ].map((child)=>child.offsetWidth).reduce((sum, width)=>sum + width, 0);
        const actionsWidth = buttonsGroup.offsetWidth;
        const buttonsGroupHeight = buttonsGroup.offsetHeight;
        const additionalWidthControl = 15; //px
        // total line width if placed inline
        const totalWidth = paddingLeft + marginLeft + lastWidth + //marginRight +
        //paddingRight +
        additionalWidthControl + actionsWidth;
        console.log("totalWidth ", totalWidth);
        console.log("parentWidth ", parentWidth);
        console.log("buttonsGroupHeight ", buttonsGroupHeight);
        // decide
        if (totalWidth > parentWidth) resourceSection.style.paddingBottom = paddingBottom + buttonsGroupHeight + "px";
    }
}
function $039319c8bf8150c3$var$insertDescription(descriptionPreview, description) {
    const descriptionText = document.createElement('p');
    if (description != null && description.length > 0) descriptionText.innerText = description;
    else descriptionText.innerText = 'the author supplied no description';
    descriptionPreview.append(descriptionText);
}
function $039319c8bf8150c3$var$insertTagsAsTextLine(tagsSection, tags) {
    const tagsLine = document.createElement('p');
    if (tags == null || tags.length === 0) {
        tagsLine.innerText = 'no tags';
        return null;
    }
    tagsLine.setAttribute("id", "tags-line");
    if (tags[tags.length - 1] === ',') tags = tags.substring(0, tags.length - 1);
    tagsLine.innerText = "Tags: ";
    for(let i in tags){
        const tag = document.createElement('a');
        tag.innerText = tags[i];
        tag.href = (0, $7NPUP.SITE_URL) + '/search/branches=' + tags[i] + '/page=1';
        tagsLine.append(tag);
        if (i != tags.length - 1) tagsLine.append(', ');
    }
    tagsSection.append(tagsLine);
}
function $039319c8bf8150c3$var$insertTagsWithHeaderAndBoxes(tagsSection, tags) {
    const tagsCollector = document.createElement('div');
    tagsCollector.setAttribute("id", "tags-collector");
    const tagsLabel = document.createElement('h3');
    tagsLabel.innerText = "Tags";
    if (tags[tags.length - 1] === ',') tags = tags.substring(0, tags.length - 1);
    const tagsArray = tags.split(',');
    for (let tagInfo of tagsArray){
        const tag = document.createElement('div');
        const tagLabel = document.createElement('p');
        tagLabel.innerText = tagInfo;
        tag.append(tagLabel);
        tag.classList.add("tag");
        tagsCollector.append(tag);
    }
    tagsSection.append(tagsLabel);
    tagsSection.append(tagsCollector);
}
function $039319c8bf8150c3$export$9279a785613cece8(author) {
    const rightSideBar = document.getElementById('right-side-bar');
    if (author !== null && author !== undefined) {
        const authorType = author.type;
        if (authorType === null || authorType === undefined) return;
        else if (authorType === "REGULAR_USER") rightSideBar.append($039319c8bf8150c3$var$createAuthorInfo(author));
        else if (authorType === "ANONYMOUS") {
            const authorInfo = {
                username: null,
                accountName: "Anonymous author",
                accountBio: "This branch was submitted anonymously. No one has claimed authorship over it yet.",
                profilePic: null
            };
            rightSideBar.append($039319c8bf8150c3$var$createAuthorInfo(authorInfo));
        }
    }
}
function $039319c8bf8150c3$var$createAuthorInfo(author) {
    const authorInfo = document.createElement('div');
    authorInfo.setAttribute("id", "author-info");
    const regularName = document.createElement('a');
    regularName.setAttribute("id", "author-regular-name");
    regularName.innerText = author.accountName;
    regularName.href = (0, $7NPUP.SITE_URL) + '/user/page/' + author.username;
    const username = document.createElement('a');
    username.setAttribute("id", "author-username");
    username.innerText = '@' + author.username;
    username.href = (0, $7NPUP.SITE_URL) + '/user/page/' + author.username;
    const authorNameAndUsername = (0, $iqZMU.createElement)('div', 'author-name-and-username', null);
    if (author.accountName !== null) authorNameAndUsername.append(regularName);
    if (author.username !== null && author.username !== undefined) authorNameAndUsername.append(username);
    const profilePic = document.createElement('img');
    profilePic.setAttribute("id", "author-profile-pic");
    //profilePic.src = author.profilePic;
    if (author.profilePic !== null && author.profilePic.picPath !== null && author.userStatus !== 'suspended' && author.userStatus !== 'banned') (0, $5ZqHF.insertImageValue)(profilePic, author.profilePic.picPath);
    else profilePic.src = (0, $7NPUP.SITE_URL) + '/images/icons/profile_account.png';
    if (author.userStatus === 'suspended' || author.userStatus === 'banned') {
        profilePic.src = '/images/icons/profile_account.png';
        username.innerText = 'This user has been restricted';
        regularName.remove();
    }
    const profilePicAndNames = (0, $iqZMU.createElement)('div', 'author-profile-pic-and-names', null);
    const profileBio = document.createElement('p');
    profileBio.setAttribute("id", "author-bio");
    profileBio.innerText = author.accountBio;
    const subscribeButton = document.createElement('button');
    subscribeButton.setAttribute("id", "author-subscribe-button");
    subscribeButton.innerText = "Subscribe";
    profilePicAndNames.append(profilePic, authorNameAndUsername);
    authorInfo.append(profilePicAndNames);
    authorInfo.append(profileBio);
    //authorInfo.append(subscribeButton);
    return authorInfo;
}



var $eOEAK = parcelRequire("eOEAK");

var $iqZMU = parcelRequire("iqZMU");
parcelRequire("fKjmJ");
parcelRequire("9VVEN");
parcelRequire("31Bjw");

var $7NPUP = parcelRequire("7NPUP");

var $81Clf = parcelRequire("81Clf");
parcelRequire("jFzoB");

var $cCBwI = parcelRequire("cCBwI");

var $iqZMU = parcelRequire("iqZMU");

var $1vUzf = parcelRequire("1vUzf");
function $2bbe299be9061714$export$e4212a973a1cd483(branchId, subscribersCount = null) {
    const subscribeToFamilyButton = (0, $iqZMU.createElement)('button', null, [
        'subscribe-to-family-button'
    ]);
    const subscribeCaption = (0, $iqZMU.createElement)('p', null, [
        'subscribe-to-family-button-caption'
    ]);
    subscribeCaption.innerText = 'Subscribe';
    subscribeToFamilyButton.append(subscribeCaption);
    if (subscribersCount !== null && subscribersCount > 0) {
        const subscribersCountCaption = (0, $iqZMU.createElement)('p', null, [
            'subscribe-to-family-button-subscribers-count'
        ]);
        subscribersCountCaption.innerText = (0, $1vUzf.abbreviateNumber)(subscribersCount);
        subscribeToFamilyButton.append(subscribersCountCaption);
    }
    (0, $81Clf.makeNewButton)(subscribeToFamilyButton, 'light-black', 'white', null, 'lighten');
    subscribeToFamilyButton.addEventListener('click', ()=>$2bbe299be9061714$var$subscribeToFamily(branchId, subscribersCount, subscribeToFamilyButton));
    return subscribeToFamilyButton;
}
function $2bbe299be9061714$export$a3834fa86ebf6777(branchId, subscribersCount = null) {
    const unsubscribeFromFamilyButton = (0, $iqZMU.createElement)('button', null, [
        'subscribe-to-family-button'
    ]);
    const unsubscribeCaption = (0, $iqZMU.createElement)('p', null, [
        'subscribe-to-family-button-caption'
    ]);
    unsubscribeCaption.innerText = 'Subscribed';
    unsubscribeFromFamilyButton.append(unsubscribeCaption);
    if (subscribersCount !== null && subscribersCount > 0) {
        const subscribersCountCaption = (0, $iqZMU.createElement)('p', null, [
            'subscribe-to-family-button-subscribers-count'
        ]);
        subscribersCountCaption.innerText = (0, $1vUzf.abbreviateNumber)(subscribersCount);
        unsubscribeFromFamilyButton.append(subscribersCountCaption);
    }
    (0, $81Clf.makeNewButton)(unsubscribeFromFamilyButton, 'grey', 'black', null, 'darken');
    unsubscribeFromFamilyButton.addEventListener('click', ()=>$2bbe299be9061714$var$unsubscribeFromFamily(branchId, subscribersCount, unsubscribeFromFamilyButton));
    return unsubscribeFromFamilyButton;
}
async function $2bbe299be9061714$var$subscribeToFamily(branchId, subscribersCount = null, subscribeToFamilyButton) {
    if (localStorage.getItem('branchof_access_token') === null || localStorage.getItem('branchof_access_token') === undefined) {
        (0, $cCBwI.insertPlaqueAndAlertWindow)('You are not logged in! Log in to subscribe to this user.');
        return null;
    }
    const response = await fetch((0, $7NPUP.API_GATEWAY) + `subscription/branch/create/branchId=${branchId}`, {
        method: 'POST',
        headers: {
            'Token-Auth': localStorage.getItem('branchof_access_token')
        }
    });
    if (response.status === 200) {
        const unsubscribeFromFamilyButton = $2bbe299be9061714$export$a3834fa86ebf6777(branchId, subscribersCount + 1);
        subscribeToFamilyButton.insertAdjacentElement('beforebegin', unsubscribeFromFamilyButton);
        subscribeToFamilyButton.remove();
    } else if (response.status === 204) (0, $cCBwI.insertPlaqueAndAlertWindow)("The user doesn't exist");
    else if (response.status === 403) (0, $cCBwI.insertPlaqueAndAlertWindow)("Can't subscribe to yourself. Quit trying to suck your own cock!");
    else (0, $cCBwI.insertPlaqueAndAlertWindow)("Something went wrong while subscribing.");
}
async function $2bbe299be9061714$var$unsubscribeFromFamily(branchId, subscribersCount = null, unsubscribeFromFamilyButton) {
    if (localStorage.getItem('branchof_access_token') === null || localStorage.getItem('branchof_access_token') === undefined) {
        (0, $cCBwI.insertPlaqueAndAlertWindow)('You are not logged in! Log in to unsubscribe to this user.');
        return null;
    }
    const response = await fetch((0, $7NPUP.API_GATEWAY) + `subscription/branch/delete/branchId=${branchId}`, {
        method: 'DELETE',
        headers: {
            'Token-Auth': localStorage.getItem('branchof_access_token')
        }
    });
    if (response.status === 200) {
        const subscribeToFamilyButton = $2bbe299be9061714$export$e4212a973a1cd483(branchId, subscribersCount - 1);
        unsubscribeFromFamilyButton.insertAdjacentElement('beforebegin', subscribeToFamilyButton);
        unsubscribeFromFamilyButton.remove();
    } else if (response.status === 204) (0, $cCBwI.insertPlaqueAndAlertWindow)("The user doesn't exist");
    else if (response.status === 401) (0, $cCBwI.insertPlaqueAndAlertWindow)("Your login has expired");
    else (0, $cCBwI.insertPlaqueAndAlertWindow)("Something went wrong while subscribing.");
}


function $3347340f54a4bee6$export$4d0b0545518c3287(nodeObject, subscriptionStatus, subscribersCount) {
    const nodeFamilySection = (0, $iqZMU.createElement)('section', 'node-family', null);
    const exploreFieldMini = (0, $eOEAK.createExploreMini)(nodeObject);
    const nodeFamilyCaptionAndSubscribeButton = (0, $iqZMU.createElement)('div', 'node-family-caption-and-subscribe-button', null);
    const nodeFamilyCaption = (0, $iqZMU.createElement)('h6', 'node-family-caption', null);
    nodeFamilyCaption.innerText = 'The Family Tree';
    let nodeFamilySubscribeButton;
    if (subscriptionStatus === true) nodeFamilySubscribeButton = (0, $2bbe299be9061714$export$a3834fa86ebf6777)(nodeObject.id, subscribersCount);
    else nodeFamilySubscribeButton = (0, $2bbe299be9061714$export$e4212a973a1cd483)(nodeObject.id, subscribersCount);
    nodeFamilyCaptionAndSubscribeButton.append(nodeFamilyCaption, nodeFamilySubscribeButton);
    nodeFamilySection.append(nodeFamilyCaptionAndSubscribeButton, exploreFieldMini);
    return nodeFamilySection;
}


parcelRequire("25dWo");

var $jFzoB = parcelRequire("jFzoB");

var $fIqNW = parcelRequire("fIqNW");

var $chUGo = parcelRequire("chUGo");
parcelRequire("iqZMU");

var $7NPUP = parcelRequire("7NPUP");

var $cCBwI = parcelRequire("cCBwI");

var $bwCNb = parcelRequire("bwCNb");

var $iqZMU = parcelRequire("iqZMU");

var $iqZMU = parcelRequire("iqZMU");

var $81Clf = parcelRequire("81Clf");
function $113d6ea2b19153ca$export$3f8237ea517c3dce(submitCommentFunction, newCommentElementFunction) {
    if (!(newCommentElementFunction instanceof Function)) return null;
    if (!(submitCommentFunction instanceof Function)) return null;
    const newCommentElement = (0, $iqZMU.createElement)('div', null, [
        'new-comment'
    ]);
    const textArea = (0, $iqZMU.createElement)('textarea', null, [
        'new-comment-textarea'
    ]);
    const buttonsGroup = (0, $iqZMU.createElement)('div', null, [
        'new-comment-buttons'
    ]);
    const cancelButton = (0, $iqZMU.createElement)('button', null, [
        'new-comment-cancel-button'
    ]);
    const submitButton = (0, $iqZMU.createElement)('button', null, [
        'new-comment-submit-button'
    ]);
    cancelButton.innerText = 'Cancel';
    submitButton.innerText = 'Post';
    submitButton.addEventListener('click', ()=>{
        const message = textArea.value;
        if (message.length === 0) return null;
        submitCommentFunction(message, newCommentElement);
        textArea.value = '';
    });
    (0, $81Clf.makeNewButton)(cancelButton, 'gray', 'light-black', null, 'darken', null);
    (0, $81Clf.makeNewButton)(submitButton, 'light-black', 'white', null, 'lighten', null);
    buttonsGroup.append(cancelButton);
    buttonsGroup.append(submitButton);
    newCommentElement.append(textArea);
    newCommentElement.append(buttonsGroup);
    newCommentElement.textArea = textArea;
    newCommentElement.buttonsGroup = buttonsGroup;
    newCommentElement.cancelButton = cancelButton;
    newCommentElement.submitButton = submitButton;
    newCommentElementFunction(newCommentElement);
    return newCommentElement;
}



var $7NPUP = parcelRequire("7NPUP");
async function $1a276b55c59777ba$export$1dd9c623542e0e34(branchId, page) {
    const url = new URL((0, $7NPUP.API_GATEWAY) + "commentaries/get/list/for-branch");
    url.searchParams.append("branchId", branchId);
    url.searchParams.append("page", page);
    const response = await fetch(url, {
        method: 'GET'
    });
    if (!response.ok) return null;
    const data = await response.json();
    return data;
}
async function $1a276b55c59777ba$export$76153f512f4497f9(ids) {
    const url = new URL((0, $7NPUP.API_GATEWAY) + "commentaries/get/list/by-ids");
    url.searchParams.append("ids", ids);
    const response = await fetch(url, {
        method: 'GET'
    });
    if (!response.ok) return null;
    const data = await response.json();
    return data;
}





var $iqZMU = parcelRequire("iqZMU");

var $5ULc3 = parcelRequire("5ULc3");
parcelRequire("5ZqHF");

var $5ZqHF = parcelRequire("5ZqHF");

var $iqZMU = parcelRequire("iqZMU");

var $7NPUP = parcelRequire("7NPUP");
function $99b944cb85bec006$export$fcc74809bf1f1f66(userInfo) {
    const userShortInfoGroup = (0, $iqZMU.createElement)('div', null, [
        'usig'
    ]);
    const userProfilePic = (0, $iqZMU.createElement)('img', null, [
        'usig-profile-pic'
    ]);
    const userNameAndUsername = (0, $iqZMU.createElement)('div', null, [
        'usig-name-and-username'
    ]);
    const username = (0, $iqZMU.createElement)('a', null, [
        'usig-username'
    ]);
    userShortInfoGroup.append(userProfilePic);
    userShortInfoGroup.append(userNameAndUsername);
    if (userInfo.userStatus === 'suspended' || userInfo.userStatus === 'banned') {
        userProfilePic.src = '/images/icons/profile_account.png';
        console.log("User's avatar: ", userProfilePic.src);
        username.innerText = 'This user has been restricted';
        userNameAndUsername.classList.add('user-info-restricted');
    } else {
        if (userInfo.profilePic !== null && userInfo.profilePic.picPath !== null) (0, $5ZqHF.insertImageValue)(userProfilePic, userInfo.profilePic.picPath);
        else userProfilePic.src = '/images/icons/profile_account.png';
        username.innerText = '@' + userInfo.username;
        username.href = (0, $7NPUP.SITE_URL) + '/user/page/' + userInfo.username;
        if (userInfo.accountName !== null) {
            const userAccountName = (0, $iqZMU.createElement)('a', null, [
                'usig-account-name'
            ]);
            userAccountName.innerText = userInfo.accountName;
            userAccountName.href = (0, $7NPUP.SITE_URL) + '/user/page/' + userInfo.username;
            userNameAndUsername.append(userAccountName);
            userShortInfoGroup.userAccountName = userAccountName;
        }
    }
    userNameAndUsername.append(username);
    userShortInfoGroup.userProfilePic = userProfilePic;
    userShortInfoGroup.userNameAndUsername = userNameAndUsername;
    userShortInfoGroup.username = username;
    return userShortInfoGroup;
}



var $81Clf = parcelRequire("81Clf");
function $e664d0cead215615$export$554d5f3eff24735f(commentaryInfo, initiationFunctionsObject = null) {
    const commentaryElement = (0, $iqZMU.createElement)('div', null, [
        'comment'
    ]);
    const userShortInfoGroup = (0, $99b944cb85bec006$export$fcc74809bf1f1f66)(commentaryInfo.authorInfo);
    const message = (0, $iqZMU.createElement)('p', null, [
        'comment-message'
    ]);
    message.innerText = commentaryInfo.message;
    const dateAndButtons = (0, $iqZMU.createElement)('div', null, [
        'comment-date-and-buttons'
    ]);
    const date = (0, $iqZMU.createElement)('p', null, [
        'comment-date'
    ]);
    date.innerText = (0, $5ULc3.formatDateForPost)(new Date(commentaryInfo.date));
    const replyButton = (0, $iqZMU.createElement)('button', null, [
        'comment-reply-button'
    ]);
    replyButton.innerText = 'Reply';
    const repliesSection = $e664d0cead215615$var$createRepliesSection(commentaryInfo.repliesIds, initiationFunctionsObject);
    replyButton.addEventListener('click', ()=>{
        const originalSubmitReply = initiationFunctionsObject.submitReply;
        const replyWindowElement = (0, $113d6ea2b19153ca$export$3f8237ea517c3dce)((message, newReplyElement)=>originalSubmitReply(message, newReplyElement, commentaryInfo.id), initiationFunctionsObject.newReplyInitFunction);
        const cancelButton = replyWindowElement.cancelButton;
        cancelButton.addEventListener('click', ()=>{
            replyWindowElement.remove();
            replyButton.classList.remove('hidden-info');
        });
        repliesSection.repliesSectionComments.insertAdjacentElement('afterbegin', replyWindowElement);
        replyButton.classList.add('hidden-info');
    });
    (0, $81Clf.makeNewButton)(replyButton, 'white', 'light-black', null, 'darken', null);
    dateAndButtons.append(date, replyButton);
    commentaryElement.append(userShortInfoGroup);
    commentaryElement.append(message);
    commentaryElement.append(dateAndButtons);
    commentaryElement.append(repliesSection);
    commentaryElement.userShortInfoGroup = userShortInfoGroup;
    commentaryElement.userProfilePic = userShortInfoGroup.userProfilePic;
    commentaryElement.userNameAndUsername = userShortInfoGroup.userNameAndUsername;
    commentaryElement.message = message;
    commentaryElement.dateAndButtons = dateAndButtons;
    commentaryElement.date = date;
    commentaryElement.replyButton = replyButton;
    commentaryElement.repliesSection = repliesSection;
    if (initiationFunctionsObject !== null && initiationFunctionsObject.commentaryInitFunction instanceof Function) initiationFunctionsObject.commentaryInitFunction(commentaryElement);
    return commentaryElement;
}
function $e664d0cead215615$var$createRepliesSection(repliesIds, initiationFunctionsObject = null) {
    const repliesSection = (0, $iqZMU.createElement)('div', null, [
        'comment-reply-section'
    ]);
    const repliesSectionButton = (0, $iqZMU.createElement)('div', null, [
        'comment-reply-section-button'
    ]);
    const repliesSectionButtonRectangle = (0, $iqZMU.createElement)('div', null, [
        'comment-reply-section-button-rectangle'
    ]);
    const repliesSectionComments = (0, $iqZMU.createElement)('div', null, [
        'comment-reply-section-comments'
    ]);
    repliesSectionComments.loadedRepliesCount = 0;
    if (repliesIds !== null && repliesIds.length > 0) {
        const repliesToLoad = repliesIds.slice(0, 4);
        const repliesToLoadLater = repliesIds.slice(4);
        const loadRepliesButton = $e664d0cead215615$var$createLoadRepliesButton(repliesToLoad, repliesToLoadLater, repliesSectionComments, initiationFunctionsObject);
        repliesSectionComments.append(loadRepliesButton);
        repliesSection.loadRepliesButton = loadRepliesButton;
        repliesSectionComments.borderButton = loadRepliesButton;
        repliesSectionComments.sectionCollapsed = true;
    }
    repliesSectionButton.append(repliesSectionButtonRectangle);
    repliesSectionButton.addEventListener('click', ()=>$e664d0cead215615$var$clickRepliesBorder(repliesSection));
    (0, $81Clf.makeNewButtonAffectingDifferentElement)(repliesSectionButton, repliesSectionButtonRectangle, 'rgb(128, 128, 128)', null, null, 'darken', null);
    repliesSectionButton.repliesSectionButtonRectangle = repliesSectionButtonRectangle;
    repliesSection.append(repliesSectionButton);
    repliesSection.append(repliesSectionComments);
    repliesSection.repliesSectionButton = repliesSectionButton;
    repliesSection.repliesSectionComments = repliesSectionComments;
    return repliesSection;
}
function $e664d0cead215615$var$clickRepliesBorder(repliesSection) {
    const repliesSectionComments = repliesSection.repliesSectionComments;
    console.log(repliesSectionComments.loadRepliesButton, "loadRepliesButton");
    console.log(repliesSectionComments.sectionCollapsed, "sectionCollapsed");
    if (repliesSectionComments.sectionCollapsed === true) {
        if (repliesSectionComments.borderButton !== null) repliesSectionComments.borderButton.click();
        repliesSectionComments.sectionCollapsed = false;
    } else {
        const uncollapseButton = (0, $iqZMU.createElement)('button', null, [
            'comment-load-replies-button'
        ]);
        const repliesSectionComments = repliesSection.repliesSectionComments;
        uncollapseButton.innerText = `+${repliesSectionComments.loadedRepliesCount} replies`;
        const repliesSectionCommentsChildren = repliesSectionComments.children;
        for (let i of repliesSectionCommentsChildren)i.classList.add('hidden-info');
        uncollapseButton.addEventListener('click', ()=>{
            for (let i of repliesSectionCommentsChildren)i.classList.remove('hidden-info');
            repliesSectionComments.sectionCollapsed = false;
            uncollapseButton.remove();
        });
        repliesSectionComments.borderButton = uncollapseButton;
        repliesSectionComments.append(uncollapseButton);
        repliesSectionComments.sectionCollapsed = true;
    }
}
function $e664d0cead215615$var$createLoadRepliesButton(repliesToLoad, repliesToLoadLater, insertElement, initiationFunctionsObject = null) {
    const loadRepliesButton = (0, $iqZMU.createElement)('button', null, [
        'comment-load-replies-button'
    ]);
    loadRepliesButton.innerText = `+${repliesToLoad.length} replies`;
    loadRepliesButton.addEventListener('click', ()=>{
        $e664d0cead215615$var$loadRepliesAndInsert(repliesToLoad, repliesToLoadLater, insertElement, initiationFunctionsObject).then(()=>{
            loadRepliesButton.remove();
        });
        insertElement.sectionCollapsed = false;
    });
    (0, $81Clf.makeNewButton)(loadRepliesButton, 'white', 'light-black', null, 'darken', null);
    if (initiationFunctionsObject !== null && initiationFunctionsObject.loadRepliesButtonInitFunction instanceof Function) initiationFunctionsObject.loadRepliesButtonInitFunction(loadRepliesButton);
    return loadRepliesButton;
}
async function $e664d0cead215615$var$loadRepliesAndInsert(repliesToLoad, repliesToLoadLater, insertElement, initiationFunctionsObject) {
    const commentariesInfo = await (0, $1a276b55c59777ba$export$76153f512f4497f9)(repliesToLoad);
    insertElement.borderButton = null;
    const commentariesElements = [];
    if (commentariesInfo !== null && commentariesInfo.length > 0) {
        for (let i of commentariesInfo){
            const commentary = $e664d0cead215615$export$554d5f3eff24735f(i, initiationFunctionsObject);
            commentariesElements.push(commentary);
        }
        insertElement.loadedRepliesCount = insertElement.loadedRepliesCount + commentariesInfo.length;
        insertElement.sectionCollapsed = false;
    }
    console.log("load commentariesInfo", commentariesInfo);
    if (repliesToLoadLater !== null && repliesToLoadLater.length > 0) {
        const nextRepliesToLoad = repliesToLoadLater.slice(0, 4);
        const nextRepliesToLoadLater = repliesToLoadLater.slice(4);
        const loadNextRepliesButton = $e664d0cead215615$var$createLoadRepliesButton(nextRepliesToLoad, nextRepliesToLoadLater, insertElement, initiationFunctionsObject);
        commentariesElements.push(loadNextRepliesButton);
        insertElement.borderButton = loadNextRepliesButton;
    }
    if (commentariesElements.length > 0) insertElement.append(...commentariesElements);
}




var $iqZMU = parcelRequire("iqZMU");

var $81Clf = parcelRequire("81Clf");
async function $f5c0b0e9f6a87b66$export$4a6ea4c50bc2fa5d(commentariesAndNextInfo, commentFunctionsParam, nextPage) {
    const commentGroup = (0, $iqZMU.createElement)('div', null, [
        'comment-group'
    ]);
    const commentariesInfo = commentariesAndNextInfo.commentaries;
    if (commentariesInfo === null || commentariesInfo === undefined || commentariesInfo.length === 0) {
        const noCommentsCaption = (0, $iqZMU.createElement)('p', null, [
            'comment-group-no-comment-caption'
        ]);
        noCommentsCaption.innerText = "there are no comments yet.";
        commentGroup.append(noCommentsCaption);
        commentGroup.noCommentsCaption = noCommentsCaption;
        return commentGroup;
    }
    if (!(commentFunctionsParam.commentGroupInitFunction instanceof Function)) throw new Error("Not a function");
    const elementsToAppend = [];
    const commentElements = [];
    for (let i of commentariesInfo){
        const commentElement = (0, $e664d0cead215615$export$554d5f3eff24735f)(i, commentFunctionsParam);
        elementsToAppend.push(commentElement);
        commentElements.push(commentElement);
    }
    if (commentariesAndNextInfo.isThereMore === true) {
        const loadMoreCommentariesButton = $f5c0b0e9f6a87b66$var$createLoadCommentariesButtonWithPage(nextPage, commentFunctionsParam, commentGroup);
        elementsToAppend.push(loadMoreCommentariesButton);
        commentGroup.loadMoreCommentariesButton = loadMoreCommentariesButton;
    }
    console.log("elementsToAppend", elementsToAppend);
    commentGroup.append(...elementsToAppend);
    commentGroup.commentElements = commentElements;
    commentFunctionsParam.commentGroupInitFunction(commentGroup);
    return commentGroup;
}
function $f5c0b0e9f6a87b66$var$createLoadCommentariesButtonWithPage(page, commentFunctionsParam, insertElement) {
    const loadCommentariesButton = (0, $iqZMU.createElement)('button', null, [
        'comment-group-load-comments'
    ]);
    const loadCommentariesButtonLine = (0, $iqZMU.createElement)('div', null, [
        'comment-group-load-comments-line'
    ]);
    const loadCommentariesButtonWhiteSpace = (0, $iqZMU.createElement)('div', null, [
        'comment-group-load-comments-white-space'
    ]);
    const loadCommentariesButtonCaption = (0, $iqZMU.createElement)('p', null, [
        'comment-group-load-comments-caption'
    ]);
    (0, $81Clf.makeNewButtonAffectingDifferentElement)(loadCommentariesButton, loadCommentariesButtonLine, 'light-black', null, null, 'lighten', null);
    (0, $81Clf.makeNewButtonAffectingDifferentElement)(loadCommentariesButton, loadCommentariesButtonCaption, 'light-black', 'white', null, 'lighten', null);
    loadCommentariesButtonWhiteSpace.append(loadCommentariesButtonCaption);
    loadCommentariesButton.append(loadCommentariesButtonLine, loadCommentariesButtonWhiteSpace);
    loadCommentariesButtonCaption.innerText = 'More comments';
    loadCommentariesButton.addEventListener('click', ()=>{
        $f5c0b0e9f6a87b66$var$loadAndInsertComemntariesWithPage(page, commentFunctionsParam, insertElement);
        loadCommentariesButton.remove();
    });
    if (!(commentFunctionsParam.loadOriginalCommentariesButtonInitFunction instanceof Function)) return new Error("Not a function");
    commentFunctionsParam.loadOriginalCommentariesButtonInitFunction(loadCommentariesButton);
    return loadCommentariesButton;
}
async function $f5c0b0e9f6a87b66$var$loadAndInsertComemntariesWithPage(page, commentFunctionsParam, insertElement) {
    if (!(commentFunctionsParam.fetchCommentariesInCommentGroupFunction instanceof Function)) return new Error("Not a function");
    const commentariesAndNextInfo = await commentFunctionsParam.fetchCommentariesInCommentGroupFunction(page);
    const commentariesInfo = commentariesAndNextInfo.commentaries;
    const isThereMore = commentariesAndNextInfo.isThereMore;
    if (commentariesInfo === null || commentariesInfo.length === 0) return null;
    const commentaries = [];
    for (let i of commentariesInfo){
        const commentElement = (0, $e664d0cead215615$export$554d5f3eff24735f)(i, commentFunctionsParam);
        commentaries.push(commentElement);
    }
    if (isThereMore === true) {
        const nextLoadButton = $f5c0b0e9f6a87b66$var$createLoadCommentariesButtonWithPage(page + 1, commentFunctionsParam, insertElement);
        commentaries.push(nextLoadButton);
    }
    insertElement.append(...commentaries);
}



var $7NPUP = parcelRequire("7NPUP");

var $cCBwI = parcelRequire("cCBwI");

var $jFzoB = parcelRequire("jFzoB");

var $lz1lC = parcelRequire("lz1lC");
const $70fb820230314852$var$MAX_COMMENT_LENGTH = 10000;
const $70fb820230314852$var$commentFunctionsParam = {
    newCommentElementFunction: $70fb820230314852$var$newCommentElementFunction,
    submitCommentFunction: $70fb820230314852$var$submitCommentFunction,
    commentGroupInitFunction: $70fb820230314852$var$commentGroupInitFunction,
    commentaryInitFunction: $70fb820230314852$var$commentaryInitFunction,
    loadOriginalCommentariesButtonInitFunction: $70fb820230314852$var$loadOriginalCommentariesButtonInitFunction,
    fetchCommentariesInCommentGroupFunction: $70fb820230314852$var$fetchCommentariesInCommentGroupFunction,
    newReplyInitFunction: $70fb820230314852$var$newReplyInitFunction,
    submitReply: $70fb820230314852$var$submitReply,
    loadRepliesButtonInitFunction: $70fb820230314852$var$loadRepliesButtonInitFunction
};
function $70fb820230314852$export$4744090a42219c7b(branchId) {
    const commentSection = (0, $iqZMU.createElement)('section', 'branch-comment-section', null);
    const commentSectionCaption = (0, $iqZMU.createElement)('h6', 'branch-comment-section-caption', null);
    commentSectionCaption.innerText = 'Comment section';
    const loadingScreen = (0, $jFzoB.createLoadingScreen)(100, 100, 100);
    loadingScreen.loadingCaption.remove();
    // Set up IntersectionObserver to trigger when the loader becomes visible
    const observer = new IntersectionObserver((entries, observer)=>{
        entries.forEach((entry)=>{
            if (entry.isIntersecting) {
                // When the loader is visible, load and insert posts
                $70fb820230314852$var$createCommentSectionElements(branchId).then((commentElements)=>{
                    commentSection.append(...commentElements);
                    loadingScreen.remove();
                });
                observer.unobserve(entry.target); // Stop observing after triggering
            }
        });
    });
    observer.observe(loadingScreen); // Start observing the loader element
    commentSection.append(commentSectionCaption);
    commentSection.append(loadingScreen);
    return commentSection;
}
async function $70fb820230314852$export$75730a5bdbf1035b(branchId) {
    const commentSection = (0, $iqZMU.createElement)('section', 'branch-comment-section', null);
    const elements = [];
    const commentSectionCaption = (0, $iqZMU.createElement)('h6', 'branch-comment-section-caption', null);
    commentSectionCaption.innerText = 'Comment section';
    elements.push(commentSectionCaption);
    const commentElements = await $70fb820230314852$var$createCommentSectionElements(branchId);
    elements.push(...commentElements);
    commentSection.append(...elements);
    return commentSection;
}
async function $70fb820230314852$var$createCommentSectionElements(branchId) {
    const commentariesInfoPromise = (0, $1a276b55c59777ba$export$1dd9c623542e0e34)(branchId, 1);
    const elements = [];
    const loginToken = localStorage.getItem('branchof_access_token');
    const originalSubmitReply = $70fb820230314852$var$commentFunctionsParam.submitReply;
    $70fb820230314852$var$commentFunctionsParam.submitReply = (message, newReplyElement, parentId)=>originalSubmitReply(message, newReplyElement, parentId, loginToken);
    const originalCommentaryInitFunction = $70fb820230314852$var$commentFunctionsParam.commentaryInitFunction;
    $70fb820230314852$var$commentFunctionsParam.commentaryInitFunction = (commentElement)=>originalCommentaryInitFunction(commentElement, loginToken);
    const originalFetchCommentariesInCommentGroupFunction = $70fb820230314852$var$commentFunctionsParam.fetchCommentariesInCommentGroupFunction;
    $70fb820230314852$var$commentFunctionsParam.fetchCommentariesInCommentGroupFunction = (page)=>originalFetchCommentariesInCommentGroupFunction(page, branchId);
    const commentariesInfo = await commentariesInfoPromise;
    const commentsGroup = await (0, $f5c0b0e9f6a87b66$export$4a6ea4c50bc2fa5d)(commentariesInfo, $70fb820230314852$var$commentFunctionsParam, 2);
    if (loginToken !== null && loginToken !== null) {
        const newCommentElement = (0, $113d6ea2b19153ca$export$3f8237ea517c3dce)((message, newCommentElement)=>$70fb820230314852$var$commentFunctionsParam.submitCommentFunction(message, newCommentElement, branchId, loginToken, commentsGroup), $70fb820230314852$var$commentFunctionsParam.newCommentElementFunction);
        newCommentElement.cancelButton.remove();
        elements.push(newCommentElement);
    }
    elements.push(commentsGroup);
    return elements;
}
function $70fb820230314852$var$newCommentElementFunction(newCommentElement) {
    newCommentElement.id = 'branch-comment-new-original';
    newCommentElement.classList.add('branch-comment-new-comment');
    const textarea = newCommentElement.textArea;
    textarea.maxlength = 5000;
    textarea.placeholder = 'Add a comment...';
}
async function $70fb820230314852$var$submitCommentFunction(message, newCommentElement, branchId, loginToken, commentGroup) {
    if (!(0, $lz1lC.ParamValidator).isSafeTextNullable(message, $70fb820230314852$var$MAX_COMMENT_LENGTH)) {
        (0, $cCBwI.insertPlaqueAndAlertWindow)('Your comment is either too long or contains inappropriate characters');
        return;
    }
    const loadingCircleScreen = (0, $jFzoB.createLoadingScreen)(25, 25, 50);
    loadingCircleScreen.loadingCaption.remove();
    const submitButton = newCommentElement.submitButton;
    submitButton.classList.add('hidden-info');
    newCommentElement.buttonsGroup.append(loadingCircleScreen);
    const url = new URL((0, $7NPUP.API_GATEWAY) + "commentaries/create/original");
    url.searchParams.append("branchId", branchId);
    url.searchParams.append("message", message);
    const response = await fetch(url, {
        method: 'POST',
        headers: {
            "Token-Auth": loginToken
        }
    });
    const status = response.status;
    if (status === 200) {
        const userInfo = {
            profilePic: {
                picPath: null
            },
            username: localStorage.getItem('branchof_access_username'),
            accountName: null,
            userStatus: null
        };
        const commentInfo = {
            authorInfo: userInfo,
            message: message,
            repliesIds: null,
            date: new Date()
        };
        const newComment = (0, $e664d0cead215615$export$554d5f3eff24735f)(commentInfo);
        const noCommentsCaption = commentGroup.noCommentsCaption;
        if (noCommentsCaption !== null && noCommentsCaption !== undefined) noCommentsCaption.remove();
        commentGroup.insertAdjacentElement('afterbegin', newComment);
    } else if (status === 401) (0, $cCBwI.insertPlaqueAndAlertWindow)('Your login session has expired.');
    setTimeout(()=>{
        submitButton.classList.remove('hidden-info');
        loadingCircleScreen.remove();
    }, 500);
}
function $70fb820230314852$var$commentGroupInitFunction(commentGroup) {
    commentGroup.id = 'branch-comment-section-group';
}
function $70fb820230314852$var$commentaryInitFunction(commentElement, loginToken) {
    commentElement.userShortInfoGroup.classList.add("branch-comment-user-pic-and-names");
    commentElement.userProfilePic.classList.add("branch-comment-user-pic");
    commentElement.userNameAndUsername.classList.add("branch-comment-name-and-username");
    commentElement.message.classList.add("branch-comment-message");
    commentElement.dateAndButtons.classList.add("branch-comment-date-and-buttons");
    commentElement.date.classList.add("branch-comment-date");
    commentElement.replyButton.classList.add("branch-comment-reply-button");
    commentElement.repliesSection.classList.add("branch-comment-reply-section");
    if (loginToken === null || loginToken === undefined) commentElement.replyButton.remove();
}
function $70fb820230314852$var$loadOriginalCommentariesButtonInitFunction(loadCommentariesButton) {
    loadCommentariesButton.classList.add('branch-comment-load-original-button');
}
async function $70fb820230314852$var$fetchCommentariesInCommentGroupFunction(page, branchId) {
    const data = await (0, $1a276b55c59777ba$export$1dd9c623542e0e34)(branchId, page);
    console.log("fetchCommentariesInCommentGroupFunction", data);
    if (data === null) return [];
    return data;
}
function $70fb820230314852$var$newReplyInitFunction(newReply) {
    newReply.classList.add('branch-comment-new-reply');
    newReply.classList.add('branch-comment-new-comment');
    const textarea = newReply.textArea;
    textarea.maxlength = 5000;
    textarea.placeholder = 'I agree with you! <3';
}
async function $70fb820230314852$var$submitReply(message, newReplyElement, parentId, loginToken) {
    const url = new URL((0, $7NPUP.API_GATEWAY) + "commentaries/create/reply");
    url.searchParams.append("parentId", parentId);
    url.searchParams.append("message", message);
    const response = await fetch(url, {
        method: 'POST',
        headers: {
            "Token-Auth": loginToken
        }
    });
    const status = response.status;
    if (status === 200) {
        const userInfo = {
            profilePic: {
                picPath: null
            },
            username: localStorage.getItem('branchof_access_username'),
            accountName: null,
            userStatus: null
        };
        const commentInfo = {
            authorInfo: userInfo,
            message: message,
            repliesIds: null,
            date: new Date()
        };
        const newComment = (0, $e664d0cead215615$export$554d5f3eff24735f)(commentInfo);
        newReplyElement.insertAdjacentElement('afterend', newComment);
        newReplyElement.remove();
    } else if (status === 204) (0, $cCBwI.insertPlaqueAndAlertWindow)('The commentary you are replying to doesn\'t exist');
    else if (status === 401) (0, $cCBwI.insertPlaqueAndAlertWindow)('Your login session has expired.');
}
function $70fb820230314852$var$loadRepliesButtonInitFunction(loadRepliesButton) {
    loadRepliesButton.classList.add('branch-comment-load-replies-button');
}



var $fKjmJ = parcelRequire("fKjmJ");

var $czNeG = parcelRequire("czNeG");
$f8b3a821ff7a0547$var$initNodePage();
async function $f8b3a821ff7a0547$var$initNodePage() {
    const mainContent = document.getElementById('main-content');
    const loadingScreen = (0, $jFzoB.createLoadingScreen)(450, 1400, 100);
    mainContent.append(loadingScreen);
    const body = document.querySelector('body');
    const main = document.querySelector('main');
    body.insertAdjacentElement('afterbegin', (0, $chUGo.createPageHeader)());
    const leftSection = document.getElementById('left-side-bar');
    leftSection.append(...(0, $fIqNW.createLeftSideContent)(localStorage.getItem("branchof_access_token"), localStorage.getItem("branchof_access_profile_pic"), localStorage.getItem("branchof_access_username"), localStorage.getItem("branchof_access_profile_name")));
    const nodeId = $f8b3a821ff7a0547$var$getNodeId();
    const [nodeObject, authorInfo, likeStatus, subscriptionStatus] = await $f8b3a821ff7a0547$var$getNodeInfo(nodeId);
    if (nodeObject === 'restricted') {
        const contentRestricted = (0, $bwCNb.createContentRestrictedWindow)('This branch has been made unavailable by the moderation, most likely due to breaking community rules or engaging in indecent behavior.', 'content-restricted-branch');
        loadingScreen.remove();
        mainContent.append(contentRestricted);
    } else if (nodeObject !== null) {
        nodeObject.id = nodeId;
        const subscribersCount = $f8b3a821ff7a0547$var$extractSubscribersCount(nodeObject);
        const exploreSection = (0, $3347340f54a4bee6$export$4d0b0545518c3287)(nodeObject, subscriptionStatus, subscribersCount);
        main.append(exploreSection);
        const nodeMainElements = await (0, $039319c8bf8150c3$export$4084c9ec4b0e2fec)(nodeId, nodeObject, authorInfo, likeStatus);
        const modStatus = nodeObject.modStatus;
        if (modStatus !== null) {
            if (modStatus === "plus_18") {
                const black18Screen = (0, $czNeG.createPlus18Screen)();
                black18Screen.create18WarningIconInBeginning();
                black18Screen.makeIconRhombus();
                black18Screen.createGoBackButton();
                const plaque = (0, $fKjmJ.createPlaque)();
                plaque.append(black18Screen);
                main.classList.add('blurred');
                plaque.style.padding = "0";
                black18Screen.style.height = "100%";
                black18Screen.black18ScreenButton.addEventListener('click', ()=>{
                    plaque.remove();
                    main.classList.remove('blurred');
                });
            }
        }
        loadingScreen.remove();
        mainContent.append(...nodeMainElements);
        $f8b3a821ff7a0547$var$postRenderFunction(main, nodeId);
        (0, $039319c8bf8150c3$export$9279a785613cece8)(authorInfo);
        const commentSection = (0, $70fb820230314852$export$4744090a42219c7b)(nodeId);
        mainContent.append(commentSection);
    }
}
function $f8b3a821ff7a0547$var$getNodeId() {
    let nodeId = window.location.href;
    nodeId = nodeId.replace((0, $7NPUP.SITE_URL) + "/branch/view-page/", "");
    return nodeId;
}
async function $f8b3a821ff7a0547$var$getNodeInfo(nodeId) {
    let token = localStorage.branchof_access_token;
    let response = null;
    if (token === null || token === undefined) response = await fetch((0, $7NPUP.API_GATEWAY) + 'branches/get/node&long-author/' + nodeId, {
        method: 'GET',
        headers: {
            'Accept': 'application/json'
        }
    });
    else response = await fetch((0, $7NPUP.API_GATEWAY) + 'branches/get/node&long-author/' + nodeId, {
        method: 'GET',
        headers: {
            'Accept': 'application/json',
            'Token-Auth': `${token}`
        }
    });
    if (response.status === 200) {
        const data = await response.json();
        console.log(data);
        return [
            data.branch,
            data.userInfo,
            data.likeStatus,
            data.subscriptionStatus
        ];
    } else if (response.status === 204) {
        (0, $cCBwI.insertPlaqueAndAlertWindow)("This branch doesn't exist");
        return [
            null,
            null,
            null
        ];
    } else if (response.status === 401) {
        const data = await response.json();
        console.log(data);
        (0, $cCBwI.insertPlaqueAndAlertWindow)("Your login session has expired");
        return [
            data.branch,
            data.userInfo,
            data.likeStatus,
            data.subscriptionStatus
        ];
    } else if (response.status === 403) return [
        'restricted',
        null,
        null
    ];
    else {
        (0, $cCBwI.insertPlaqueAndAlertWindow)("Something went wrong while loading up the branch!");
        return [
            null,
            null,
            null
        ];
    }
}
function $f8b3a821ff7a0547$var$postRenderFunction(mainContent, nodeId) {
    const exploreMiniFieldWrapper = mainContent.querySelector('.explore-mini-field-wrapper');
    exploreMiniFieldWrapper.initiateAfterRender();
    const nodeInfoElement = mainContent.querySelector('#branch-info');
    nodeInfoElement.onRender();
    exploreMiniFieldWrapper.centerExploreFieldAroundTheBranch(nodeId);
}
function $f8b3a821ff7a0547$var$extractSubscribersCount(nodeObject) {
    const subscribersCount = nodeObject.subscribersCount;
    if (subscribersCount !== null && subscribersCount > 0) return subscribersCount;
    if (nodeObject.parent !== null) return $f8b3a821ff7a0547$var$extractSubscribersCount(nodeObject.parent);
    return subscribersCount;
}


//# sourceMappingURL=node.67671e6f.js.map
